import Vue from 'vue';
import moment from 'moment';
import { getPaymentMethod } from '@/assets/js/api/payment-method';
import { getOpenstackCredentials } from '@/assets/js/api/openstack';
import { getContainers, getContainerDetails, setContainerDetails } from '@/assets/js/api/object-store';
import { getVolumes, getVolumeDetails, getVolumeTypes, createTransfers, cancelTransfer, deleteVolumeSnapshot, getVolumeQuota } from '@/assets/js/api/volume-store';
import { getImages, getImagesNext } from '@/assets/js/api/image';
import { getInstancesDetail, getInstanceDetails, instanceAction, attachVolume, detachVolume, getInterfaces, getComputeQuota, getComputeUsage } from '@/assets/js/api/instance';
import { getAvailabilityZones } from '@/assets/js/api/availability-zones';
import { getSnapshots, getSnapshotDetails } from '@/assets/js/api/snapshot';
import { getFlavors } from '@/assets/js/api/flavors';
import { getLoadBalancers, getLoadBalancersDetails, getLBPools, getLBListeners, getLoadBalancerFlavors, getLBMembers, getLBMonitors, deleteLBMember, deleteLBMonitor } from '@/assets/js/api/load-balancer';
import { getNetworks, getNetworkDetails, deleteNetwork, getPorts, getPortDetails, getRouters, getRouter, getSubnets, getSubnetDetails, deleteSubnet, getIps, associateIp, getSecurityGroups, deleteSecurityGroupRule, getNetworkQuota } from '@/assets/js/api/network';
import { getKeypairs } from '@/assets/js/api/keypairs';
import { getCredentials, getApplicationCredentials, getAccessRules, createApplicationCredential } from '@/assets/js/api/credentials';
import { getDNSZones, getDNSZoneRecords, getDNSZoneDetails, getDNSRecordDetails } from '@/assets/js/api/dns';
// import { getDatabases, getDatabaseDetails, deleteDatabase, deleteDatabaseDatabase, deleteDatabaseBackup } from '@/assets/js/api/database';
import { deleteDatabase, deleteDatabaseDatabase, deleteDatabaseBackup } from '@/assets/js/api/database';
// import { getBackups } from '@/assets/js/api/backup';
import { getSecrets } from '@/assets/js/api/secrets';
import { getReversDNS, getFixedReversDNS } from '@/assets/js/api/dns';
import { createEmkCluster, getEmkClusters, getEmkProjectExtend, getEmkCLusterInfo, getEmkNameSpaces, getGardenerExtensions, getEmkCloudProfiles, createEmkProject, getEmkProject, getEmkSecrets, createEmkSecret, getEmkMembers, getEmkMemberDetails } from '@/assets/js/api/emk';
import { getAdjustments } from '@/assets/js/api/adjustment';
import { getOsUser } from '@/assets/js/api/current-user';
import { getVolumeBackups, getVolumeBackupDetails } from '@/assets/js/api/volume-backup';
// import { differenceInHours } from 'date-fns';

export default Vue.mixin({

  data() {
    return {
        isDev: localStorage.getItem('isDev') ? true : false,
        messageNumber: 0,
    }
  },
  methods: {
    async fetchQuotas() {
        setTimeout(() => {
            this.fetchComputeQuota();
            this.fetchVolumeQuota();
            this.fetchNetworkQuota();
        }, 1000);
    },

    listPaymentMethods() {
        getPaymentMethod(this.$store.state.customer.info.id)
        .then((response) => {
            let data = []
            response.data.sort((a, b) => a.order - b.order);
            this.$store.commit('billing/SET_LIST', response.data);
            this.$store.commit('billing/UPDATE_KEY');
        })
        .catch((error) => {
            console.error(error);
            this.showNotification('error', `Fetching your payment methods has failed`);
            this.$store.commit('billing/SET_LIST', 'error');
        });
    },

    async fetchObjectContainers(name, region, path) {
        let serviceName = 'objectStore';
        let servicesUrls = this.$store.state.services.list['object-store'];
        if (region) {
            let currentRegionUrl =  servicesUrls[region];
            servicesUrls = {};
            servicesUrls[region] = currentRegionUrl;
        }
        const requestPromises = [];
        Object.keys(servicesUrls).forEach((key) => {
            const promise = getContainers(servicesUrls[key], false, [key][0])
            .then((response) => {
                  let regionName = servicesUrls[key].split('.')[0].split('://')[1];
                  response.data.forEach((item) => {
                      item.objects = [];
                  });
                  if (name) {
                      this.$store.commit('objectStore/HAS_OBJECTS', false);
                      this.fetchObjectContainerDetails(name, path, regionName);
                  }
                  return this.addRegionToData(regionName, response.data, serviceName);
            })
            requestPromises.push(promise);
        });
        this.promiseAllSettled(requestPromises, serviceName);
    },

    fetchObjectContainerDetails(name, path, region) {
        this.$store.commit('objectStore/OBJECTS_LOADING', true);
        getContainerDetails(this.$store.state.services.list['object-store'][region], name, path, region)
        .then((response) => {
          response.headers.hasDetails = true;
          response.headers.name = name;
          response.headers.region = region;
          this.$store.commit('objectStore/UPDATE', response.headers);
            if (response.data.length > 0) {
                response.data.name = name;
                response.data.region = region;
                this.$store.commit('objectStore/SET_OBJECTS', response.data);
            } else {
              if (path) {
                this.$store.commit('objectStore/SET_OBJECTS', false);
              }
            }
            this.$store.commit('objectStore/HAS_DETAILS', false);
            this.$store.commit('objectStore/HAS_DETAILS', true);
            this.$store.commit('objectStore/UPDATE_KEY');
            this.$store.commit('objectStore/OBJECTS_LOADING', false);
        })
        .catch((error) => {
            console.error(error);
            this.showNotification('error', `Can't get container details of ${name}`);
        });
    },

    async fetchOpenstackCredentials() {
        this.isLoading = true;
        getOpenstackCredentials()
        .then((response) => {
            this.$store.dispatch('osCredentials/RENEW', response.data);
            this.$store.commit('osCredentials/HAS_DATA', true);
            this.isLoading = false;
        })
        .catch((error) => {
            this.isLoading = false;
            console.error(error);
            this.showNotification('error', `Fetching your credentials has failed`);
        })
    },

    async fetchVolumes(listData) {
        let queryParams = await this.createQueryParams(listData, 'volumes');
        let serviceName = 'volumev3';
        let servicesUrls = this.$store.state.services.list[serviceName];
        const requestPromises = [];
        Object.keys(servicesUrls).forEach((key) => {
            const promise = getVolumes(servicesUrls[key], [key][0], queryParams)
            .then((response) => {
                  let regionName = servicesUrls[key].split('.')[0].split('://')[1];
                  return this.addRegionToData(regionName, response.data.volumes);
            })
            requestPromises.push(promise);
        });
        this.promiseAllSettled(requestPromises, serviceName);
    },

    async fetchVolumeBackups() {
        let serviceName = 'volumev3';
        let servicesUrls = this.$store.state.services.list[serviceName];
        const requestPromises = [];
        Object.keys(servicesUrls).forEach((key) => {
            const promise = getVolumeBackups(servicesUrls[key], [key][0])
            .then((response) => {
                let regionName = servicesUrls[key].split('.')[0].split('://')[1];
                this.$store.commit('volumev3/BACKUP_IS_LOADING', false);
                return this.addRegionToData(regionName, response.data.backups);
            })
            requestPromises.push(promise);
        });
        this.promiseAllSettled(requestPromises, serviceName, 'SET_BACKUPS');
    },

    async fetchVolumeBackupsByData(region, networkId, queryParams) {
        getVolumeBackups(this.$store.state.services.list['volumev3'][region], region, networkId, queryParams)
        .then((response) => {
            let data = response.data.backups;
            data.forEach((backup) => {
                backup.region = region;
            })
            this.parentData = data;
            this.isLoading = false;
        })
        .catch((error) => {
            this.noSubnets = true;
            this.isLoading = false;
        });
    },

    async fetchVolumeTypes() {
        let serviceName = 'volumev3';
        let servicesUrls = this.$store.state.services.list[serviceName];
        const requestPromises = [];
        Object.keys(servicesUrls).forEach((key) => {
            const promise = getVolumeTypes(servicesUrls[key], [key][0])
            .then((response) => {
                  let regionName = servicesUrls[key].split('.')[0].split('://')[1];
                  return this.addRegionToData(regionName, response.data.volume_types);
            })
            requestPromises.push(promise);
        });
        this.promiseAllSettled(requestPromises, serviceName, 'SET_TYPES');
    },

    addRegionToData(regionName, responseData, serviceName) {
        responseData.forEach((singleResource, i) => {
              singleResource.region = regionName;
              singleResource.singleKey = 0;
              if (serviceName && serviceName === 'object-store') {
                item.objects = [];
              } else if (serviceName && serviceName === 'fixedIps') {
                singleResource.fixedIp = true;
              }
        });
        return responseData;
    },

    async volumeStatusCheck(data) {
        data.forEach((item) => {
            if (this.pollingVolumeStatus(item.status)) {
                let interValNum = 10000;
                if (item.status === 'checking') {
                    interValNum = 100;
                }
                let handle = setInterval(() => {
                    getVolumeDetails(this.$store.state.services.list['volumev3'][item.region], item.id, item.region)
                    .then((response) => {
                        this.$store.commit('volumev3/UPDATE', response.data.volume);
                        this.updateResourceData('volumev3', response.data.volume);
                        if (!this.pollingVolumeStatus(response.data.volume.status)) {
                            clearInterval(handle);
                        }
                    })
                    .catch((error) => {
                        if (error.response != undefined && error.response.status === 404) {
                          clearInterval(handle);
                          this.fetchInstancesDetail();
                          this.showNotification('success', 'Deleting your volume is successful');
                        }
                    });
                }, interValNum);
          }
        })
    },

    pollingVolumeStatus(status) {
        if (status.includes('error') || status === 'available' || status === 'in-use' || status === 'awaiting-transfer') {
            return false;
        } else {
            return true;
        }
    },

    async volumeBackupStatusCheck(data) {
        data.forEach((item) => {
        if (this.pollingVolumeBackupStatus(item.status)) {
                let handle = setInterval(() => {
                    getVolumeBackupDetails(this.$store.state.services.list['volumev3'][item.region], item.id, item.region)
                    .then((response) => {
                        this.$store.commit('volumev3/UPDATE_VOLUME_BACKUP', response.data.backup);
                        if (!this.pollingVolumeBackupStatus(response.data.backup.status)) {
                            clearInterval(handle);
                        }
                    })
                    .catch((error) => {
                        if (error.response != undefined && error.response.status === 404) {
                            clearInterval(handle);
                            this.fetchInstancesDetail();
                            this.showNotification('success', 'Deleting your volume is successful');
                        }
                    });
                }, 10000);
          }
        })
    },

    pollingVolumeBackupStatus(status) {
        if (status.includes('ing') && status !== 'error_deleting') {
            return true;
        } else {
            return false;
        }
    },

    async fetchImages(defaultQuery, listData) {
        let queryParams = await this.createQueryParams(listData, 'images');
        if(defaultQuery === '?visibility=public') {
            let hasPublicImages = localStorage.getItem('publicImages') ? localStorage.getItem('publicImages') : false;
            if (hasPublicImages) {
                let publicImageData = JSON.parse(hasPublicImages);
                if (!publicImageData.expiry || new Date().getTime() > publicImageData.expiry) {
                    localStorage.removeItem('publicImages');
                    this.fetchImages(defaultQuery, queryParams);
                } else {
                    this.$store.dispatch('image/SET', publicImageData.data);
                }
                return
            }
        }
        let serviceName = 'image';
        let servicesUrls = this.$store.state.services.list[serviceName];
        const requestPromises = [];
        Object.keys(servicesUrls).forEach((key) => {
            const promise = getImages(servicesUrls[key], [key][0], queryParams, defaultQuery)
            .then((response) => {
                let regionName = servicesUrls[key].split('.')[0].split('://')[1];
                if (response.data.next) {
                    this.fetchImagesNext(response.data.next, regionName, queryParams);
                } else {
                    this.$store.commit('image/IS_LOADING', false);
                }
                return this.addRegionToData(regionName, response.data.images);
            })
            requestPromises.push(promise);
        });
        if (defaultQuery === 'owner') {
            this.promiseAllSettled(requestPromises, serviceName, 'SET_OWNED');
        } else {
            this.promiseAllSettled(requestPromises, serviceName);
        }
    },

    promiseAllSettled(requestPromises, serviceName, extraData, dataInComponent) {
      Promise.allSettled(requestPromises)
      .then(response => {
            let successFullResponses = response.filter(item => item.status === 'fulfilled');
            let errorFullResponses = response.filter(item => item.status !== 'fulfilled');
            this.convertPromiseResources(successFullResponses, serviceName, extraData, dataInComponent);

            if (errorFullResponses.length > 0) {
                let errorMessage = this.errorMessageFromPromise(errorFullResponses);
            }
      });
    },

    async convertPromiseResources(data, serviceName, extraData, dataInComponent) {
        let allResources = []
        data.forEach((singleData) => {
          if (singleData.value) {
              if (extraData !== 'SET_QUOTA') {
                  singleData.value.forEach((item) => {
                       allResources.push(item);
                  });
              } else {
                  allResources.push(singleData.value);
              }
           }
        });
        if (!dataInComponent) {
            if (extraData && extraData !== 'noExtraData') {
                this.$store.commit(serviceName + '/' + extraData, allResources);
            } else if (serviceName === 'image' || serviceName === 'images' || serviceName === 'volumev3' || serviceName === 'dns' || serviceName === 'pool' || serviceName === 'lbMonitor'  || serviceName === 'loadBalancer') {
                this.$store.commit(serviceName + '/IS_LOADING', false);
                this.$store.commit(serviceName + '/UPDATE_KEY');
            } else if (serviceName === 'flavor' || serviceName === 'port') {
                this.$store.commit(serviceName + '/HAS_DATA', true);
            } else if (serviceName === 'credential' || serviceName === 'securityGroup' || serviceName === 'keyPair' || serviceName === 'router' || serviceName === 'objectStore' || serviceName === 'port' || serviceName === 'subnet' || serviceName === 'appCredential' || serviceName === 'listener' || serviceName === 'secrets'){
                this.$store.commit(serviceName + '/IS_LOADING', false);
            } else if (serviceName === 'snapshot' || serviceName === 'port' || serviceName === 'ip') {
                this.$store.commit(serviceName + '/IS_LOADING', false);
                this.$store.commit(serviceName + '/HAS_DATA', true);
                this.$store.commit(serviceName + '/UPDATE_KEY');
            }

            if (serviceName === 'pool') {
                this.$store.commit('loadBalancer/UPDATE_KEY');
            }

            if (serviceName === 'image' && !extraData) {
                let data = {}
                data.expiry = this.addDaysToDate(new Date().getTime(), 1)
                data.data = allResources;
                localStorage.setItem('publicImages', JSON.stringify(data));
            }

            if (serviceName === 'flavor') {
                let data = {}
                data.expiry = this.addDaysToDate(new Date().getTime(), 1)
                data.data = allResources;
                localStorage.setItem('flavors', JSON.stringify(data));
            }

            if (serviceName === 'port') {
                this.$store.commit('network/IS_LOADING', false);
            }

            if (serviceName === 'objectStore') {
                this.$store.commit('objectStore/RENEW_DETAILS');
            }

            if (!extraData) {
                this.$store.dispatch(serviceName + '/SET', allResources);
            }

            if (serviceName === 'volumev3' && !extraData) {
                this.volumeStatusCheck(allResources);
            }

            if (serviceName === 'volumev3' && extraData === 'SET_BACKUPS') {
                this.volumeBackupStatusCheck(allResources);
            }

            if (serviceName === 'snapshot') {
                this.snapshotStatusCheck(allResources);
            }
        } else {
            if (dataInComponent.includes('SET_TOPO')) {
                this.$store.commit('network/' + dataInComponent, allResources);
            } else {
                this[dataInComponent] = allResources;
            }
        }
    },

    async fetchImagesNext(url, region, queryParams) {
      getImagesNext(this.$store.state.services.list['image'][region], url, region, queryParams, defaultQuery)
          .then((response) => {
            response.data.images.forEach((item) => {
                item.region = region;
                this.$store.dispatch('image/ADD', item);
            });

            if (response.data.next) {
                this.fetchImagesNext(response.data.next, region);
            }
          })
          .catch((error) => {
              console.error(error);
              this.$store.commit('image/IS_LOADING', false);
              this.showNotification('error', 'Fetching images has failed');

              // this.$store.commit('securityGroup/IS_LOADING', false);
              // this.showNotification('error', `${ error.response.data.NeutronError.message}`);
          });
    },

    async getListData(listName) {
        let storageArray = JSON.parse(localStorage.getItem('listData'));
        if (storageArray) {
            if (storageArray[0] && (!storageArray[0].creationDate)) {
                storageArray = false;
                localStorage.removeItem('listData');
            } else {
                storageArray = storageArray.find(item => item.name === listName);
            }
            if (storageArray) {
                this.listData = storageArray;
            } else {
                this.createQueryParams(false, listName);
                this.getListData(listName);
            }
        } else {
            this.createQueryParams(false, listName);
            this.getListData(listName);
        }
    },

    async createQueryParams(listData, listName) {
        let queryString = `?limit=1000`;
        if (listName === 'images') {
            queryString = `?limit=1000&sort=name:asc`;
        }
        let newListData = {
            numPageItems: 1000,
            pageNumber: 1,
            orderData: {
                sort_key: false,
                sort_dir: false,
            },
            filter: ['', ''],
            name: listName,
            view: {},
        }
        if (listName === 'volumes') {
            newListData.view.columns = ['Attached To', 'Size','Type','Disk Tag','Bootable','Created At'];
            newListData.view.disAbledcolumns = ['Size','Type','Disk Tag','Bootable'];
        } else if (listName === 'instances') {
            newListData.orderData.sort_key = 'created_at';
            newListData.orderData.sort_dir = 'asc';
            newListData.view.columns = ['image_ref', 'key_name', 'locked', 'created_at'];
            newListData.view.disAbledcolumns = ['image_ref', 'Floating IP', 'Flavor', 'Tags', 'locked'];
        } else if (listName === 'images') {
            newListData.view.columns = ['Container Format','Disk Format','Created At'];
            newListData.view.disAbledcolumns = ['Container Format'];
        } else if (listName === 'snapshots') {
            newListData.view.columns = ['Status', 'Linked volumes','Created At'];
            newListData.view.disAbledcolumns = ['Status','Created At'];
        } else if (listName === 'networks') {
            newListData.view.columns = ['External', 'Shared','Subnets','Created At'];
            newListData.view.disAbledcolumns = ['External', 'Shared','Subnets'];
        } else if (listName === 'ports') {
            newListData.view.columns = ['Network','Mac Address','IP Addresses','Created At'];
            newListData.view.disAbledcolumns = [];
        } else if (listName === 'routers') {
            newListData.view.columns = ['External Fixed IP','Open External Gateway','Created At'];
            newListData.view.disAbledcolumns = [];
        } else if (listName === 'emk') {
            newListData.view.columns = ['Region','HA','Created At'];
            newListData.view.disAbledcolumns = [];
        }

        if (listData) {
            if (listData.filter) {
                newListData.filter = listData.filter;
                if (listData.filter[1].length > 1) {
                    queryString = queryString + `&${ listData.filter[1] }=${ listData.filter[0] }`;
                }
            }
            if (listData.pageNumber) {
                newListData.pageNumber = listData.pageNumber;
            }

            if (listData.orderData && listData.orderData.sort_key && listData.orderData.sort_dir) {
                newListData.orderData = listData.orderData;
                let sortKey = listData.orderData.sort_key;
                queryString = queryString + `&sort_key=${ sortKey }&sort_dir=${ listData.orderData.sort_dir }`;
            }

            if (listData.view && listData.view.disAbledcolumns) {
                newListData.view.disAbledcolumns = listData.view.disAbledcolumns;
            }
            newListData.queryString = queryString;
        }
        // console.log('queryParams newListData', newListData.orderData)
        await this.checkListDataLocalStorage(listName, newListData);
        return queryString;
    },

    async checkListDataLocalStorage(listName, newListData) {
        let storageArray = localStorage.getItem('listData') != null ? JSON.parse(localStorage.getItem('listData')) : false;
        let finallArray = []
        if (storageArray) {
            finallArray = storageArray.filter(item => item.name !== listName);
        }
        finallArray.push(newListData);
        finallArray[0].creationDate = new Date().getTime();
        localStorage.setItem('listData', JSON.stringify(finallArray));
    },

    async fetchInstancesDetail(listData, dataInComponent) {
        // console.log('queryParams listData: ', listData)
        let queryParams = await this.createQueryParams(listData, 'instances');
        // console.log('queryParams: ', queryParams)
        let servicesUrls = this.$store.state.services.list['compute'];
        const requestPromises = [];
        Object.keys(servicesUrls).forEach((key) => {
            const promise = getInstancesDetail(servicesUrls[key], [key][0], queryParams)
            .then((response) => {
                response.data.servers.forEach((server, i) => {
                      server.region = servicesUrls[key].split('.')[0].split('://')[1];
                      server.singleKey = 0;
                });
                return response.data.servers;
            })
            requestPromises.push(promise);
        });

        Promise.allSettled(requestPromises)
        .then(response => {
              let successFullResponses  = response.filter(item => item.status === 'fulfilled')
              this.convertInstances(successFullResponses, dataInComponent)
              if (response.filter(item => item.status !== 'fulfilled').length > 0) {
                  this.showNotification('error', 'Fetching some instances has failed');
              }
        });
    },

    async fetchInstanceDetails(region, id) {
        if (!this.isDev) {
          getInstanceDetails(this.$store.state.services.list['compute'][region], id, region)
          .then((response) => {
                let data = response.data.server;
                data.region = region;
                data.singleKey ? data.singleKey += 1 : 10;
                this.updateResourceData('instance', response.data.server);

                if (data['OS-EXT-STS:task_state'] != null || data['OS-EXT-STS:vm_state'] === 'building') {
                    this.instanceStatusCheck(data);
                }
                this.currentInstance = data;
          })
          .catch((error) => {
              this.noInstance = true;
          });
        } else {
            this.currentInstance = {"singleKey":2,"id":"da624c6a-ab99-4e66-9e15-c7f1f89fd785","name":"met-volume","status":"ACTIVE","tenant_id":"f8548e9a3e9c4a9f8ae46f927e270909","user_id":"b18db5f9271141e9992baf17327194a6","metadata":{},"hostId":"b8a15792c6f3c7a63ad1e699fef93c37f66b0f0f4a23bb2bb8913007","image":{"id":"9a8510fd-8ff8-42b1-95d9-ded0e7fd48df","links":[{"rel":"bookmark","href":"https://core.fuga.cloud:8774/images/9a8510fd-8ff8-42b1-95d9-ded0e7fd48df"}]},"flavor":{"vcpus":1,"ram":922,"disk":15,"ephemeral":0,"swap":0,"original_name":"t2.tiny","extra_specs":{"aggregate_instance_extra_specs:flavor_tier":"t","quota:cpu_period":"100000","quota:cpu_quota":"50000","quota:disk_read_iops_sec":"150","quota:disk_write_iops_sec":"75","quota:vif_inbound_average":"16384","quota:vif_outbound_average":"16384"}},"created":"2023-09-25T15:14:03Z","updated":"2024-01-02T10:03:19Z","addresses":{"public":[{"version":4,"addr":"81.24.6.28","OS-EXT-IPS:type":"fixed","OS-EXT-IPS-MAC:mac_addr":"fa:16:3e:65:d3:2a"}]},"accessIPv4":"","accessIPv6":"","links":[{"rel":"self","href":"https://core.fuga.cloud:8774/v2.1/servers/da624c6a-ab99-4e66-9e15-c7f1f89fd785"},{"rel":"bookmark","href":"https://core.fuga.cloud:8774/servers/da624c6a-ab99-4e66-9e15-c7f1f89fd785"}],"OS-DCF:diskConfig":"MANUAL","progress":0,"OS-EXT-AZ:availability_zone":"ams2-a","config_drive":"True","key_name":"ams2-key","OS-SRV-USG:launched_at":"2023-09-26T08:33:03.000000","OS-SRV-USG:terminated_at":null,"OS-EXT-STS:task_state":null,"OS-EXT-STS:vm_state":"active","OS-EXT-STS:power_state":1,"os-extended-volumes:volumes_attached":[{"id":"b56bced6-95c7-4785-ad7d-7c16362fb00c","delete_on_termination":true}],"locked":false,"locked_reason":null,"description":null,"tags":[],"trusted_image_certificates":null,"OS-EXT-SRV-ATTR:hostname":"met-volume","security_groups":[{"name":"default"}],"region":"core"};
        }
      },

    convertInstances(data, dataInComponent) {
        let allInstances = []
        data.forEach((serverList) => {
            if (serverList.value) {
                serverList.value.forEach((server) => {
                    if (server['OS-EXT-STS:task_state'] != null || server['OS-EXT-STS:vm_state'] === 'building') {
                        this.instanceStatusCheck(server);
                    }
                    allInstances.push(server);
                })
            }
        });
        if (dataInComponent) {
            this.$store.commit('network/SET_TOPO_INSTANCEDATA', allInstances);
        } else {
            this.$store.dispatch('instance/SET', allInstances);
            this.$store.commit('instance/IS_LOADING', false);
            this.$store.commit('instance/UPDATE_KEY');
        }
    },

    async instanceStatusCheck(data) {
      let handle = setInterval(() => {
        getInstanceDetails(this.$store.state.services.list['compute'][data.region], data.id, data.region)
            .then((response) => {
                this.updateResourceData('instance', response.data.server);
                if (response.data.server['OS-EXT-STS:task_state'] == null && response.data.server['OS-EXT-STS:vm_state'] !== 'building') {
                    clearInterval(handle);
                }
            })
            .catch((error) => {
               if (error.response != undefined && error.response.status === 404) {
                  clearInterval(handle);
                  this.fetchInstancesDetail();
               }
            });
        }, 5000);
    },

    async fetchFlavors() {
        let hasFlavors = localStorage.getItem('flavors') ? localStorage.getItem('flavors') : false;
        if (hasFlavors) {
            let flavorData = JSON.parse(localStorage.getItem('flavors'));
            if (!flavorData.expiry || new Date().getTime() > flavorData.expiry) {
                localStorage.removeItem('flavors');
                this.fetchFlavors();
            } else {
                this.$store.dispatch('flavor/SET', flavorData.data);
            }
            return
        } else {
            let serviceName = 'flavor';
            let servicesUrls = this.$store.state.services.list['compute'];
            const requestPromises = [];
            Object.keys(servicesUrls).forEach((key) => {
                const promise = getFlavors(servicesUrls[key], [key][0])
                .then((response) => {
                    let regionName = servicesUrls[key].split('.')[0].split('://')[1];
                    return this.addRegionToData(regionName, response.data.flavors);
                })
                requestPromises.push(promise);
            });
            this.promiseAllSettled(requestPromises, serviceName);
        }
    },

    interactiveBtn(id, action, progress, extraData, region) {
      let target = '';
      if(event.target.parentElement.classList.value === 'icon') {
          target = event.target.parentElement.parentElement;
      } else {
        target = event.target.parentElement;
      }
      if(target.classList.length === 1) {
        target.classList.add('confirm');
        target.getElementsByTagName('span')[0].innerHTML = 'Confirm';
      } else if (target.classList.length === 2) {
        target.classList.remove('confirm');
        target.classList.add('progess');
        target.getElementsByTagName('span')[0].innerHTML = progress;
        if (action === 'cancel-transfer') {
          this.cancelTransfer(id);
        } else if (action === 'detach') {
          this.detachVolumeAction(id, region);
        } else if (action === 'delete-sg-rule') {
          deleteSecurityGroupRule(this.$store.state.services.list['network'][region], id, region)
          .then((response) => {
              this.fetchSecurityGroups();
              target.classList.remove('progess');
              target.getElementsByTagName('span')[0].innerHTML = 'Delete rule';
              this.showNotification('success', `Your security group rule is deleted`);
              this.btnReturnToBeginState(target);
          })
          .catch((error) => {
              console.error(error);
              this.$store.commit('image/IS_LOADING', false);
              this.showNotification('error', `${ error.response.data.NeutronError.message}`);
              this.btnReturnToBeginState(target);
          });
        } else if (action === 'disassociateIp') {
          let data = {
              "floatingip": {
                  "port_id": null,
              }
          }
          associateIp(this.$store.state.services.list['network'][region], id , data, region)
          .then((response) => {
            this.fetchIps();
            this.showNotification('success', `Disassociation is successful`);
            this.btnReturnToBeginState(target);
            this.isLoading = false;
          })
          .catch((error) => {
              this.isLoading = false;
              console.error(error);
              this.showNotification('error', `${ error.response.data.NeutronError.message}`);
              this.btnReturnToBeginState(target);
          });
        } else if (action === 'deleteNetwork') {
          deleteNetwork(this.$store.state.services.list['network'][region], id, region)
          .then((response) => {
            this.updateResourceData();
            this.showNotification('success', `Deleting network ${id} is deleted`);
            this.btnReturnToBeginState(target);
            this.isLoading = false;
            if (this.$router.currentRoute.name === 'network') {
              this.$router.go(-1);
            }
          })
          .catch((error) => {
              this.isLoading = false;
              console.error(error);
              this.showNotification('error', `${ error.response.data.NeutronError.message}`);
              this.btnReturnToBeginState(target);
          });
        } else if (action === 'deleteSubnet') {
          deleteSubnet(this.$store.state.services.list['network'][region], id, region)
          .then((response) => {
            this.updateResourceData();
            this.showNotification('success', `Subnet ${id} is deleted`);
            this.btnReturnToBeginState(target);
            this.$root.$emit('bv::hide::modal','os-modal');
          })
          .catch((error) => {
              this.isLoading = false;
              console.error(error);
              this.showNotification('error', `${ error.response.data.NeutronError.message}`);
              this.btnReturnToBeginState(target);
          });
        } else if (action === 'detachSG') {
          let data = {
              "removeSecurityGroup": {
                  "name": id,
              }
          }
          instanceAction(this.$store.state.services.list['compute'][region], extraData.id, data, region)
          .then((response) => {
              this.fetchInstanceDetails(extraData, region);
              this.showNotification('success', 'Detaching security group is successful');
              this.btnReturnToBeginState(target, 'Detach');
          })
          .catch((error) => {
              console.error(error);
              this.showNotification('error', 'Detaching security group has failed');
              this.btnReturnToBeginState(target, 'Detach');
          });
        } else if (action === 'deleteVolumeSnapshot') {
          deleteVolumeSnapshot(this.$store.state.services.list['volumev3'][region], id, region)
          .then((response) => {
            this.showNotification('success', 'Deleting volume snapshot is successful');
            this.btnReturnToBeginState(target);
            this.$root.$emit('bv::hide::modal','os-modal');
            this.fetchSnapshots();
          })
          .catch((error) => {
              console.error(error);
              this.showNotification('error', 'Deleting volume snapshot has failed');
              this.btnReturnToBeginState(target);
          });
        } else if (action === 'togglePublic') {
            this.togglePublic(id, extraData);
        } else if (action === 'deleteLBMember') {
            this.deleteLoadBalancerMember(id, extraData, target, region);
        } else if (action === 'deleteLBMonitor') {
              this.deleteLoadBalancerMonitor(id, extraData, target, region);
        } else if (action === 'deleteDatabase') {
            deleteDatabase(this.$store.state.services.list['object-store'][region], extraData, id, region)
            .then((response) => {
              this.showNotification('success', `Deleting database is successful`);
              this.btnReturnToBeginState(target);
              this.fetchDatabases();
            })
            .catch((error) => {
                console.error(error);
                this.showNotification('error', `Deleting database has failed`);
                this.btnReturnToBeginState(target);
            });
        }  else if (action === 'deleteDatabaseUser') {
            deleteDatabaseDatabase(this.$store.state.services.list['object-store'][region], extraData, id, region)
            .then((response) => {
              this.showNotification('success', `Deleting database is successful`);
              this.btnReturnToBeginState(target);
              this.fetchDatabases();
            })
            .catch((error) => {
                console.error(error);
                this.showNotification('error', `Deleting database has failed`);
                this.btnReturnToBeginState(target);
            });
        } else if (action === 'deleteDatabaseDatabase') {
            deleteDatabaseDatabase(this.$store.state.services.list['object-store'][region], extraData, id, region)
            .then((response) => {
              this.showNotification('success', `Deleting database is successful`);
              this.btnReturnToBeginState(target);
              this.fetchDatabases();
            })
            .catch((error) => {
                console.error(error);
                this.showNotification('error', `Deleting database has failed`);
                this.btnReturnToBeginState(target);
            });
        } else if (action === 'deleteDatabaseBackup') {
            deleteDatabaseBackup(this.$store.state.services.list['object-store'][region], extraData, id, region)
            .then((response) => {
              this.showNotification('success', `Deleting database backup is successful`);
              this.btnReturnToBeginState(target);
              this.fetchDatabases();
            })
            .catch((error) => {
                console.error(error);
                this.showNotification('error', `Deleting database backup has failed`);
                this.btnReturnToBeginState(target);
            });
        }
      }
    },

    togglePublic(containerName, container) {
      let changeToPublic = true;
      if(container['x-container-read'] && container['x-container-read'] === '.r:*,.rlistings') {
          changeToPublic = false;
      }
      setContainerDetails(this.$store.state.services.list['object-store'][container.region], containerName, changeToPublic, container.region)
      .then(() => {
          if(changeToPublic) {
              this.showNotification('success', `Your container is now public`);
              this.fetchObjectContainers();
          } else {
              this.showNotification('success', `Your container is now private`);
              this.fetchObjectContainers();
          }
      })
      .catch((error) => {
          console.error(error);
          this.showNotification('error', `Updating the public access of your container is failed`);
          this.containerDetailsKey += 1;
      });
    },

    btnReturnToBeginState(target, text) {
        if (text == undefined) {
            text = 'Delete';
        }
        target.classList.remove('progess');
        target.getElementsByTagName('span')[0].innerHTML = text;
    },

    deleteLoadBalancerMember(id, poolId, target, region) {
      deleteLBMember(this.$store.state.services.list['load-balancer'][region], id, poolId, region)
      .then((response) => {
        this.showNotification('success', `Deleting load balancer member is successful`);
        if (target) {
            this.btnReturnToBeginState(target);
        }
        this.fetchLBPools();
        this.fetchLBMembers(poolId, region);
      })
      .catch((error) => {
          console.error(error);
          this.showNotification('error', `Deleting load balancer member has failed`);
          if (target) {
              this.btnReturnToBeginState(target);
          }
      });
    },

    deleteLoadBalancerMonitor(id, extraData, target, region) {
      deleteLBMonitor(this.$store.state.services.list['load-balancer'][region], id, region)
      .then((response) => {
        this.showNotification('success', `Deleting load balancer monitor is successful`);
        this.fetchLBPools();
        this.fetchLBMonitors();
      })
      .catch((error) => {
          console.error(error);
          this.showNotification('error', `Deleting load balancer monitor has failed`);
      });
    },

    attachVolume(data) {
        // data = [volume, instance]
        let bodyData = {
            "volumeAttachment": {
                "volumeId": data[0].id,
            }
        }
        let region = data[0].region;
        attachVolume(this.$store.state.services.list['compute'][region], data[1].id, bodyData, region)
        .then((response) => {
            this.updateResourceData();
            this.showNotification('success', `Your volume is successfully attached`);
        })
        .catch((error) => {
            console.error(error);
            this.volumeErrorMessage(error, `Your volume has failed to attach`);
        });
    },

    detachVolumeAction(ids, region) {
      detachVolume(this.$store.state.services.list['compute'][region], ids[1], ids[0], region)
      .then((response) => {
          this.updateResourceData();
          this.showNotification('success', `Your volume is successfully detached`);
      })
      .catch((error) => {
          console.error(error);
          this.volumeErrorMessage(error, 'Your volume has failed to detach');
      });
    },

    volumeErrorMessage(error, defaultMessage) {
        if (error.response.data.conflictingRequest) {
            this.showNotification('error', `${ error.response.data.conflictingRequest.message }`);
        } else if (error.response.data.badRequest) {
            this.showNotification('error', `${ error.response.data.badRequest.message }`);
        } else if (error.response.data.forbidden) {
            this.showNotification('error', `${ error.response.data.forbidden.message }`);
        } else {
            this.showNotification('error', defaultMessage);
        }
    },

    createTransfers(id, name) {
      if (name) {
          name = name + '-tranfer'
      } else {
          name = id + '-tranfer'
      }
      let data = {
          "transfer": {
              "volume_id": id,
              "name": name
          }
      }

      createTransfers(this.$store.state.services.list['volumev3'] ,data)
      .then((response) => {
          this.$store.dispatch('volumev3/SET_SELECTED', []);
          this.updateResourceData();
          this.$store.commit('volumev3/SET_SECRET', response.data.transfer);
          this.osModal('SHOW_VOLUME_TRANSFER_DATA');
          this.showNotification('success', `Your transfer is is created`);
      })
      .catch((error) => {
          console.error(error);
      });
    },

    cancelTransfer(id) {
      cancelTransfer(this.$store.state.services.list['volumev3'] ,id)
      .then((response) => {
          this.deselectAllItems('volumeStore');
          this.$store.dispatch('volumev3/SET_SELECTED', []);
          this.updateResourceData();
          this.showNotification('success', `Your transfer is cancelled`);
      })
      .catch((error) => {
          console.error(error);
      });
    },

    async fetchLoadBalancers(delayTime) {
          let serviceName = 'loadBalancer';
          let servicesUrls = this.$store.state.services.list['load-balancer'];
          const requestPromises = [];
          Object.keys(servicesUrls).forEach((key) => {
              const promise = getLoadBalancers(servicesUrls[key], [key][0])
              .then((response) => {
                    let regionName = servicesUrls[key].split('.')[0].split('://')[1];
                    return this.addRegionToData(regionName, response.data.loadbalancers);
              })
              requestPromises.push(promise);
          });
          this.promiseAllSettled(requestPromises, serviceName);
    },

    fetchLBFlavors() {
        let serviceName = 'loadBalancer';
        let servicesUrls = this.$store.state.services.list['load-balancer'];
        const requestPromises = [];
        Object.keys(servicesUrls).forEach((key) => {
            const promise = getLoadBalancerFlavors(servicesUrls[key], [key][0])
            .then((response) => {
                  let regionName = servicesUrls[key].split('.')[0].split('://')[1];
                  return this.addRegionToData(regionName, response.data.flavors);
            })
            requestPromises.push(promise);
        });
        this.promiseAllSettled(requestPromises, serviceName, 'SET_FLAVORS');
    },

    async LbStatusCheck(data) {
        data.forEach((item) => {
          if (item.provisioning_status && item.provisioning_status.includes('PENDING')) {
              let handle = setInterval(() => {
                  getLoadBalancersDetails(this.$store.state.services.list['load-balancer'][item.region], item.id, item.region)
                  .then((response) => {
                      this.$store.commit('loadBalancer/IS_LOADING', false);
                      this.$store.commit('loadBalancer/UPDATE_KEY');
                      // to do: pollingLbStatus is geen functie
                      if (!this.pollingLbStatus(response.data.status)) {
                          clearInterval(handle);
                      }
                  })
                  .catch((error) => {
                      if (error.response != undefined && error.response.status === 404) {
                        clearInterval(handle);
                        this.fetchLoadBalancers();
                        this.$store.commit('loadBalancer/UPDATE_KEY');
                      }
                  });
              }, 2000);
          }
        })
    },

    async fetchLBPools() {
        let serviceName = 'pool';
        let servicesUrls = this.$store.state.services.list['load-balancer'];
        const requestPromises = [];
        Object.keys(servicesUrls).forEach((key) => {
            const promise = getLBPools(servicesUrls[key], [key][0])
            .then((response) => {
                  let regionName = servicesUrls[key].split('.')[0].split('://')[1];
                  return this.addRegionToData(regionName, response.data.pools);
            })
            requestPromises.push(promise);
        });
        this.promiseAllSettled(requestPromises, serviceName);
    },

    async fetchLBListeners() {
        let serviceName = 'listener';
        let servicesUrls = this.$store.state.services.list['load-balancer'];
        const requestPromises = [];
        Object.keys(servicesUrls).forEach((key) => {
            const promise = getLBListeners(servicesUrls[key], [key][0])
            .then((response) => {
                  let regionName = servicesUrls[key].split('.')[0].split('://')[1];
                  return this.addRegionToData(regionName, response.data.listeners);
            })
            requestPromises.push(promise);
        });
        this.promiseAllSettled(requestPromises, serviceName);
    },

    async fetchLBMonitors() {
        let serviceName = 'lbMonitor';
        let servicesUrls = this.$store.state.services.list['load-balancer'];
        const requestPromises = [];
        Object.keys(servicesUrls).forEach((key) => {
            const promise = getLBMonitors(servicesUrls[key], [key][0])
            .then((response) => {
                  let regionName = servicesUrls[key].split('.')[0].split('://')[1];
                  return this.addRegionToData(regionName, response.data.healthmonitors);
            })
            requestPromises.push(promise);
        });
        this.promiseAllSettled(requestPromises, serviceName);
    },

    async fetchLBMembers(poolId, region) {
        getLBMembers(this.$store.state.services.list['load-balancer'][region], poolId, region)
        .then((response) => {
            response.data.members.forEach((item) => {
                item.region = region;
            });
            this.$store.dispatch('lbMember/SET', response.data.members);
            this.$store.commit('loadBalancer/UPDATE_KEY');
            this.$store.commit('lbMember/IS_LOADING', false);
        })
        .catch((error) => {
            console.error(error);
            this.$store.commit('lbMember/IS_LOADING', false);
            this.showNotification('error', 'Fetching LB Members has failed');
        });
    },

    async fetchRouters(listData, dataInComponent) {
        let queryParams = await this.createQueryParams(listData, 'routers');
        let serviceName = 'router';
        let servicesUrls = this.$store.state.services.list['network'];
        const requestPromises = [];
        Object.keys(servicesUrls).forEach((key) => {
            const promise = getRouters(servicesUrls[key], [key][0], queryParams)
            .then((response) => {
                  let regionName = servicesUrls[key].split('.')[0].split('://')[1];
                  return this.addRegionToData(regionName, response.data.routers);
            })
            requestPromises.push(promise);
        });
        this.promiseAllSettled(requestPromises, serviceName, false, dataInComponent);
    },

    async fetchRouterDetails(region, routerId) {
        getRouter(this.$store.state.services.list['network'][region], region, routerId)
        .then((response) => {
            let data = response.data.router;
            data.singleKey ? data.singleKey += 1 : 0;
            data.region = region;
            this.currentRouter = data;
        })
        .catch((error) => {
            console.error(error);
            this.volumeErrorMessage(error, 'Retrieving data from the router has failed');
        });
    },

    async fetchSubnets() {
        let serviceName = 'subnet';
        let servicesUrls = this.$store.state.services.list['network'];
        const requestPromises = [];
        Object.keys(servicesUrls).forEach((key) => {
            const promise = getSubnets(servicesUrls[key], [key][0])
            .then((response) => {
                  let regionName = servicesUrls[key].split('.')[0].split('://')[1];
                  return this.addRegionToData(regionName, response.data.subnets);
            })
            requestPromises.push(promise);
        });
        this.promiseAllSettled(requestPromises, serviceName);
    },

    async fetchSubnetDetails(subnetId, region) {
        getSubnetDetails(this.$store.state.services.list['network'][region], region, subnetId)
        .then((response) => {
            this.currentSubnet = response.data.subnet;
            this.currentSubnet.region = region;
            this.isLoading = false;
        })
        .catch((error) => {
            this.noSubnet = true;
            this.isLoading = false;
        });
    },

    async fetchSubnetsByData(region, networkId, queryParams) {
        getSubnets(this.$store.state.services.list['network'][region], region, networkId, queryParams)
        .then((response) => {
            let data = response.data.subnets;
            data.forEach((subnet) => {
                subnet.region = region;
            })
            this.parentData = data;
            this.isLoading = false;
        })
        .catch((error) => {
            this.noSubnets = true;
            this.isLoading = false;
        });
    },

    async fetchIps() {
        let serviceName = 'ip';
        let servicesUrls = this.$store.state.services.list['network'];
        const requestPromises = [];
        Object.keys(servicesUrls).forEach((key) => {
            const promise = getIps(servicesUrls[key], [key][0])
            .then((response) => {
                  let regionName = servicesUrls[key].split('.')[0].split('://')[1];
                  return this.addRegionToData(regionName, response.data.floatingips);
            })
            requestPromises.push(promise);
        });
        this.promiseAllSettled(requestPromises, serviceName);
    },

    async fetchIpsByData(region, extraParams) {
        await getIps(this.$store.state.services.list['network'][region], region, extraParams)
          .then((response) => {
              let data = response.data.floatingips;
              data.forEach((ip) => {
                ip.region = region;
              })
              this.parentData = data;
              this.isLoading = false;
            })
          .catch((error) => {
            this.noIps = true;
            this.isLoading = false;
        });
    },

    async fetchNetworks(listData, dataInComponent) {
        let queryParams = await this.createQueryParams(listData, 'networks');
        let serviceName = 'network';
        let servicesUrls = this.$store.state.services.list[serviceName];
        const requestPromises = [];
        Object.keys(servicesUrls).forEach((key) => {
            const promise = getNetworks(servicesUrls[key], [key][0], queryParams)
            .then((response) => {
                  let regionName = servicesUrls[key].split('.')[0].split('://')[1];
                  return this.addRegionToData(regionName, response.data.networks);
            })
            requestPromises.push(promise);
        });
        this.promiseAllSettled(requestPromises, serviceName, false, dataInComponent);
    },

    async fetchNetworkDetails(region, id) {
        if (!this.isDev) {
          getNetworkDetails(this.$store.state.services.list['network'][region], id, region)
          .then((response) => {
              let data = response.data.network;
              data.region = region;
              this.currentNetwork = data;
              // this.networkStatusCheck([data])
              this.isLoading = false;
          })
          .catch((error) => {
              this.noNetwork = true;
              this.isLoading = false;
          });
        } else {
          this.currentNetwork = {"id":"093ae4f0-caf5-49ad-9a51-7e29747b7468","name":"public","tenant_id":"6c4e52ffb35345f0b3a7cb3144922f62","admin_state_up":true,"mtu":1500,"status":"ACTIVE","subnets":["0d67f0e0-27fa-4742-8416-9a37116d74f4","657b1d28-20d3-442f-acf0-da70a0d7bfef"],"shared":true,"availability_zone_hints":[],"availability_zones":[],"ipv4_address_scope":null,"ipv6_address_scope":null,"router:external":true,"description":"","port_security_enabled":true,"dns_domain":"guests.core.fuga.cloud.","is_default":false,"tags":[],"created_at":"2020-07-29T12:23:41Z","updated_at":"2023-05-01T12:13:10Z","revision_number":33,"project_id":"6c4e52ffb35345f0b3a7cb3144922f62","region":"ams"};
        }
    },

    async fetchAvailabilityZones() {
        let serviceName = 'az';
        let servicesUrls = this.$store.state.services.list['compute'];
        const requestPromises = [];
        Object.keys(servicesUrls).forEach((key) => {
            const promise = getAvailabilityZones(servicesUrls[key], [key][0])
            .then((response) => {
                  let regionName = servicesUrls[key].split('.')[0].split('://')[1];
                  return this.addRegionToData(regionName, response.data.availabilityZoneInfo);
            })
            requestPromises.push(promise);
        });
        this.promiseAllSettled(requestPromises, serviceName);
    },

    async fetchPorts(listData, deviceId, networkId, dataInComponent) {
        let queryParams = false;
        if (!dataInComponent) {
            queryParams = await this.createQueryParams(listData, 'ports');
        }
        
        let serviceName = 'port';
        let servicesUrls = this.$store.state.services.list['network'];
        const requestPromises = [];
        Object.keys(servicesUrls).forEach((key) => {
            // apiUrl, region, queryParams, deviceId, networkId
            const promise = getPorts(servicesUrls[key], [key][0], queryParams, deviceId, networkId)
            .then((response) => {
                  let regionName = servicesUrls[key].split('.')[0].split('://')[1];
                  return this.addRegionToData(regionName, response.data.ports);
            })
            requestPromises.push(promise);
        });
        await this.promiseAllSettled(requestPromises, serviceName, false, dataInComponent);
    },

    async fetchPortDetails(region, portId) {
        getPortDetails(this.$store.state.services.list['network'][region], region, portId)
        .then((response) => {
            this.currentPort = response.data.port;
            this.currentPort.region = region;
            this.isLoading = false;
        })
        .catch((error) => {
            this.noPort = true;
            this.isLoading = false;
        });
    },

    async fetchPortsByData(region, listData, deviceId, networkId, deviceOwner, subnetID) {
        await getPorts(this.$store.state.services.list['network'][region], region, listData, deviceId, networkId, deviceOwner, subnetID)
          .then((response) => {
                let data = response.data.ports;
                data.forEach((port) => {
                    port.region = region;
                })
                this.parentData = data;
                this.isLoading = false;
            })
          .catch((error) => {
                this.noPorts = true;
                this.isLoading = false;
            });
    },

    async fetchSnapshots(listData) {
        let queryParams = await this.createQueryParams(listData, 'snapshots');
        let serviceName = 'snapshot';
        let servicesUrls = this.$store.state.services.list['volumev3'];
        const requestPromises = [];
        Object.keys(servicesUrls).forEach((key) => {
            const promise = getSnapshots(servicesUrls[key], [key][0], false, queryParams)
            .then((response) => {
                  let regionName = servicesUrls[key].split('.')[0].split('://')[1];
                  return this.addRegionToData(regionName, response.data.snapshots);
            })
            requestPromises.push(promise);
        });
        this.promiseAllSettled(requestPromises, serviceName);
    },

    async snapshotStatusCheck(data) {
      data.forEach((item) => {
        if (this.pollingSnapshotStatus(item.status)) {
          let handle = setInterval(() => {
            getSnapshotDetails(this.$store.state.services.list['volumev3'][item.region], item.id, item.region)
                .then((response) => {
                  this.$store.commit('snapshot/UPDATE', response.data.snapshot);
                  this.$store.commit('snapshot/UPDATE_KEY');
                  if (!this.pollingSnapshotStatus(response.data.snapshot.status)) {
                      clearInterval(handle);
                  }
                })
                .catch((error) => {
                    if (error.response != undefined && error.response.status === 404) {
                      clearInterval(handle);
                      this.fetchSnapshots();
                      this.$store.commit('snapshot/UPDATE_KEY');
                      this.showNotification('success', `Deleting your volume snapshot is successful`);
                    }
                });
            }, 1000);
        }
      })
    },

    pollingSnapshotStatus(status) {
        if (status.includes('available') || status === 'error' || status === 'deleted' || status === 'error_deleting') {
            return false;
        } else {
            return true;
        }
    },

    async fetchKeyPairs() {
        let serviceName = 'keyPair';
        let servicesUrls = this.$store.state.services.list['compute'];
        const requestPromises = [];
        Object.keys(servicesUrls).forEach((key) => {
            const promise = getKeypairs(servicesUrls[key], [key][0])
            .then((response) => {
                  let regionName = servicesUrls[key].split('.')[0].split('://')[1];
                  return this.addRegionToData(regionName, response.data.keypairs);
            })
            requestPromises.push(promise);
        });
        this.promiseAllSettled(requestPromises, serviceName);
    },

    async fetchKeyPairsByData(region, queryParams) {
        getKeypairs(this.$store.state.services.list['compute'][region], region, queryParams)
        .then((response) => {
            let data = response.data.keypairs;
            data.forEach((keypair) => {
                keypair.region = region;
            })
            this.parentData = data;
            this.isLoading = false;
        })
        .catch((error) => {
            this.noKeypairs = true;
            this.isLoading = false;
        });
    },

    async fetchSecrets() {
        let serviceName = 'secrets';
        let servicesUrls = this.$store.state.services.list['key-manager'];
        const requestPromises = [];
        Object.keys(servicesUrls).forEach((key) => {
            const promise = getSecrets(servicesUrls[key], [key][0])
            .then((response) => {
                  let regionName = servicesUrls[key].split('.')[0].split('://')[1];
                  return this.addRegionToData(regionName, response.data.secrets);
            })
            requestPromises.push(promise);
        });
        this.promiseAllSettled(requestPromises, serviceName);
    },

    async fetchSecurityGroups() {
        let serviceName = 'securityGroup';
        let servicesUrls = this.$store.state.services.list['network'];
        const requestPromises = [];
        Object.keys(servicesUrls).forEach((key) => {
            const promise = getSecurityGroups(servicesUrls[key], [key][0])
            .then((response) => {
                  let regionName = servicesUrls[key].split('.')[0].split('://')[1];
                  return this.addRegionToData(regionName, response.data.security_groups);
            })
            requestPromises.push(promise);
        });
        this.promiseAllSettled(requestPromises, serviceName);
    },

    async fetchSecurityGroupsByData(region, queryParams, sgId) {
        getSecurityGroups(this.$store.state.services.list['network'][region], region, queryParams, sgId)
        .then((response) => {
            if (!sgId) {
                let data = response.data.security_groups;
                data.forEach((securityGroup) => {
                    securityGroup.region = region;
                })
                this.parentData = data;
                this.isLoading = false;
            } else {
                let data = response.data.security_group;
                data.region = region;
                this.parentData = data;
                this.isLoading = false;
            }
        })
        .catch((error) => {
            this.noSecurityGroups = true;
            this.isLoading = false;
        });
    },

    async fetchNetworkQuota() {
        let serviceName = 'network';
        let servicesUrls = this.$store.state.services.list['network'];
        const requestPromises = [];
        Object.keys(servicesUrls).forEach((key) => {
            const promise = getNetworkQuota(servicesUrls[key], [key][0])
            .then((response) => {
                  let regionName = servicesUrls[key].split('.')[0].split('://')[1];
                  response.data.quota.region = regionName;
                  return response.data.quota;
            })
            requestPromises.push(promise);
        });
        this.promiseAllSettled(requestPromises, serviceName, 'SET_QUOTA');
    },

    fetchReport() {
        getDataframes(this.$store.state.services.list['rating'])
        .then((response) => {
            // this.$store.dispatch('instance/SET_QUOTA', response.data.quota_set);
        })
        .catch((error) => {
            console.error(error);
        });
    },

    async fetchComputeQuota() {
      let serviceName = 'instance';
      let servicesUrls = this.$store.state.services.list['compute'];
      const requestPromises = [];
      Object.keys(servicesUrls).forEach((key) => {
          const promise = getComputeQuota(servicesUrls[key], [key][0])
          .then((response) => {
              let regionName = servicesUrls[key].split('.')[0].split('://')[1];
              response.data.quota_set.region = regionName;
              return response.data.quota_set;
          })
          requestPromises.push(promise);
      });

      this.promiseAllSettled(requestPromises, serviceName, 'SET_QUOTA');
    },

    async fetchVolumeQuota() {
        let serviceName = 'volumev3';
        let servicesUrls = this.$store.state.services.list['volumev3'];
        const requestPromises = [];
        Object.keys(servicesUrls).forEach((key) => {
            const promise = getVolumeQuota(servicesUrls[key], [key][0])
            .then((response) => {
                  let regionName = servicesUrls[key].split('.')[0].split('://')[1];
                  response.data.quota_set.region = regionName;
                  return response.data.quota_set;
            })
            requestPromises.push(promise);
        });
        this.promiseAllSettled(requestPromises, serviceName, 'SET_QUOTA');
    },

    async fetchDatabases() {
        getComputeUsage(this.$store.state.services.list['compute'])
        // getDatabases(this.$store.state.services.list['database'])
        .then((response) => {
          let data = {"instances":[{"datastore":{"type":"mysql","version":"5.7"},"flavor":{"id":"2ed90f8e-e63c-449c-be67-31632b935503"},"id":"7de1bed8-6983-4d46-9a52-0abfbb0d27a2","ip":["10.1.0.62","172.24.5.114"],"links":[{"href":"https://127.0.0.1:8779/v1.0/9f8dd5eacb074c9f87d2d822c9092aa5/instances/7de1bed8-6983-4d46-9a52-0abfbb0d27a2","rel":"self"},{"href":"https://127.0.0.1:8779/instances/7de1bed8-6983-4d46-9a52-0abfbb0d27a2","rel":"bookmark"}],"name":"Preview example","region":"ams","status":"HEALTHY","volume":{"size":20}},{"datastore":{"type":"mongodb","version":"4.2.8"},"flavor":{"id":"04c4b5bb-4569-42ab-b0e5-56c894eb88e7"},"id":"8ae1bed8-a983-ad46-0a52-1dbfbb0dab45","ip":["10.1.0.62","172.24.5.210"],"links":[{"href":"https://127.0.0.1:8779/v1.0/9f8dd5eacb074c9f87d2d822c9092aa5/instances/7de1bed8-6983-4d46-9a52-0abfbb0d27a2","rel":"self"},{"href":"https://127.0.0.1:8779/instances/7de1bed8-6983-4d46-9a52-0abfbb0d27a2","rel":"bookmark"}],"name":"Mongo DB","region":"ams","status":"ACTIVE","volume":{"size":100}}]};
          // this.$store.dispatch('databases/SET', response.data.instances);
          this.$store.dispatch('databases/SET', data.instances);
          this.$store.commit('databases/UPDATE_KEY');
          this.$store.commit('databases/IS_LOADING', false);
        })
        .catch((error) => {
            console.error(error);
            this.$store.commit('databases/IS_LOADING', false);
            this.showNotification('error', 'Fetching databases has failed');
        });
    },

    fetchDatbaseDetails(id) {
        this.$store.commit('instance/HAS_DETAILS', false);
        getComputeUsage(this.$store.state.services.list['compute'])
        // getDatabaseDetails(this.$store.state.services.list['database'], id)
            .then((response) => {
              let data = {"instances":[{"addresses":[{"address":"10.1.0.62","type":"private"},{"address":"172.24.5.114","type":"public"}],"created":"2019-12-23T20:58:35","datastore":{"type":"mysql","version":"5.7"},"flavor":{"id":"04c4b5bb-4569-42ab-b0e5-56c894eb88e7"},"id":"7de1bed8-6983-4d46-9a52-0abfbb0d27a2","ip":["10.1.0.62","172.24.5.114"],"links":[{"href":"https://127.0.0.1:8779/v1.0/9f8dd5eacb074c9f87d2d822c9092aa5/instances/7de1bed8-6983-4d46-9a52-0abfbb0d27a2","rel":"self"},{"href":"https://127.0.0.1:8779/instances/7de1bed8-6983-4d46-9a52-0abfbb0d27a2","rel":"bookmark"}],"name":"test","region":"RegionOne","service_status_updated":"2019-12-23T21:01:11","status":"ACTIVE","updated":"2019-12-23T20:58:45","volume":{"size":1}},{"created":"2019-12-23T20:53:38","datastore":{"type":"mysql","version":"5.7"},"fault":{"created":"2019-12-23T20:53:41","details":null,"message":"Failed to create User port for instance b76a6a76-748b-4064-adec-4c9e6c9abd68"},"flavor":{"id":"6"},"id":"b76a6a76-748b-4064-adec-4c9e6c9abd68","links":[{"href":"https://127.0.0.1:8779/v1.0/9f8dd5eacb074c9f87d2d822c9092aa5/instances/b76a6a76-748b-4064-adec-4c9e6c9abd68","rel":"self"},{"href":"https://127.0.0.1:8779/instances/b76a6a76-748b-4064-adec-4c9e6c9abd68","rel":"bookmark"}],"name":"test","region":"RegionOne","service_status_updated":"2019-12-23T20:53:38","status":"ERROR","updated":"2019-12-23T20:53:41","volume":{"size":1}}]};
              // this.$store.dispatch('databases/SET', response.data.instances);
              this.$store.dispatch('databases/SET', data.instances);
              this.$store.commit('databases/UPDATE_KEY');
              this.$store.commit('databases/IS_LOADING', false);
              this.$store.commit('databases/HAS_DETAILS', true);
            })
            .catch((error) => {
                console.error(error);
                this.$store.commit('databases/IS_LOADING', false);
                this.showNotification('error', 'Fetching databases has failed');
            });
    },

    async fetchBackups() {
        // getBackups(this.$store.state.services.list['backup'])
        getImages(this.$store.state.services.list['image'])
        .then((response) => {
          let data = {"backups":[{"project_id":"752d8bd43d654e7a840bbfda77ce41af","backup_id":"96a5946a6e994a38a3d1008fbc6f3406","user_id":"a387de3311484ce58c4560486bc153f1","job_id":"df96800d16fc4d28af75c8451daf0a92","backup_metadata":{"ssh_port":22,"curr_backup_level":0,"backup_name":"freezer_mysql_backup","container":"freezer_database_backups","compression":"gzip","dry_run":"","hostname":"backup-node1","storage":"swift","vol_snap_path":"/var/lib/freezer_81856317d419498cb95f3bdffc847361/.","os_auth_version":"","client_os":"linux2","time_stamp":1603748816000,"container_segments":"","ssh_username":"","path_to_backup":"/var/lib/freezer_81856317d419498cb95f3bdffc847361/.","ssh_key":"","proxy":"","always_level":"","max_level":14,"backup_media":"fs","ssh_host":"","mode":"mysql","fs_real_path":"/var/lib/mysql/","action":"backup","client_version":"2.0.2","log_file":"/root/.freezer/freezer.log"},"client_id":"backup-node1","backup_uuid":"9598dd99e1ce42019e498c5493ae1f84","user_name":"os_backup"},{"project_id":"752d8bd43d654e7a840bbfda77ce41af","backup_id":"0cd44caf6db5486b94a04b33256a5ff4","user_id":"a387de3311484ce58c4560486bc153f1","job_id":"b30efac3ef744c45bf3062775ea3525b","backup_metadata":{"ssh_port":22,"curr_backup_level":0,"backup_name":"freezer_mysql_backup","container":"freezer_database_backups","compression":"gzip","dry_run":"","hostname":"backup-node1","storage":"swift","vol_snap_path":"/var/lib/freezer_c5d4504387f84b1e96266b6f00bf5f04/.","os_auth_version":"","client_os":"linux2","time_stamp":1603748816000,"container_segments":"","ssh_username":"","path_to_backup":"/var/lib/freezer_c5d4504387f84b1e96266b6f00bf5f04/.","ssh_key":"","proxy":"","always_level":"","max_level":14,"backup_media":"fs","ssh_host":"","mode":"mysql","fs_real_path":"/var/lib/mysql/","action":"backup","client_version":"2.0.2","log_file":"/root/.freezer/freezer.log"},"client_id":"backup-node1","backup_uuid":"2ba51cb9eff543d4b9a530b3c0d2f7cc","user_name":"os_backup"}]};
          // this.$store.dispatch('databases/SET', response.data.backups);
          this.$store.dispatch('backup/SET', data.backups);
          this.$store.commit('backup/UPDATE_KEY');
          this.$store.commit('backup/IS_LOADING', false);
        })
        .catch((error) => {
            console.error(error);
            this.$store.commit('backup/IS_LOADING', false);
            this.showNotification('error', 'Fetching backups has failed');
        });
    },

    async fetchEmkCloudProfiles() {
        if (this.isDev) {
            let data = [{"metadata":{"resourceVersion":"399519014","namespace":"garden-ij3xzee","name":"emk-project-ams2-marino-0lby","secretRef":{"name":"emk-project-ams2-marino-0lby","namespace":"garden-ij3xzee"},"cloudProviderKind":"openstack","cloudProfileName":"fugacloud","projectName":"ij3xzee","hasCostObject":true},"quotas":[],"data":{"applicationCredentialName":"****************","applicationCredentialSecret":"****************","domainName":"fuga-federated","tenantName":"ams2-marino","username":"b18db5f9271141e9992baf17327194a6"}}]
            this.$store.commit('emk/SET_PROFILES', data);
            console.log('veriosnssss: ', data[0].data.kubernetes.versions)
            this.$store.commit('emk/SET_KUBERNETES_VERSIONS', data[0].data.kubernetes.versions);
            this.startWebsocket();
            return
        }
        
        getEmkCloudProfiles()
            .then((response) => {
                this.$store.commit('emk/SET_PROFILES', response.data);
                this.$store.commit('emk/SET_KUBERNETES_VERSIONS', response.data[0].data.kubernetes.versions);
                if (this.connection) {
                    this.startWebsocket();
                }
          })
          .catch((error) => {
              console.error(error);
              this.showNotification('error', 'Fetching Cloud Profile failed');
              // this.showNotification('info', 'You will be logged in in another tab');
          });
    },


    async fetchGardenerExtensions() {
        getGardenerExtensions()
          .then((response) => {
              this.$store.commit('emk/SET_EXTENSIONS', response.data);
          })
          .catch((error) => {
              console.error(error);
          });
    },

    checkNameSpaces() {
        if (localStorage.getItem('current_namespace') != null) {
            this.$store.commit('emk/SET_CURRENT_NAMESPACE', localStorage.getItem('current_namespace'));
            this.startWebsocket(localStorage.getItem('current_namespace'));
            this.fetchEmkClusters(localStorage.getItem('current_namespace'));
            this.fetchEmkNameSpaces();
        } else{
            this.fetchEmkNameSpaces(true);
        }
    },

    async fetchEmkNameSpaces(noCurrentNameSpace) {
      getEmkNameSpaces()
          .then((response) => {
              this.$store.commit('emk/SET_NAMESPACES', response.data);
              if (noCurrentNameSpace) {
                let currentTeam = this.$store.state.team.current;

                if (currentTeam && currentTeam.emk_projects && currentTeam.emk_projects[0]) {
                    let nameSpaceName = 'garden-' + currentTeam.emk_projects[0].provider_foreign_name;
                    localStorage.setItem('current_namespace', nameSpaceName)
                    this.$store.commit('emk/SET_CURRENT_NAMESPACE', nameSpaceName);
                    this.fetchEmkClusters(nameSpaceName);
                } else {
                    this.$store.commit('emk/SET_CURRENT_NAMESPACE', response.data[0].metadata.namespace);
                    localStorage.setItem('current_namespace' , response.data[0].metadata.namespace);
                    this.fetchEmkClusters(response.data[0].metadata.namespace);
                }

                if (this.connection) {
                    this.startWebsocket();
                }
              }
          })
          .catch((error) => {
              console.error(error);
              if (noCurrentNameSpace) {
                  this.showNotification('error', 'Fetching NameSpaces failed');
              }
          });
    },

    async fetchEmkSecrets(redirectToCreate, fetchAfterCreation) {
      // let data = [{"metadata":{"resourceVersion":"9577534","namespace":"garden-okq00q6","name":"emk-dns-59c68dc2d687469ab90a0e0f0688f382-jhpv","secretRef":{"name":"emk-dns-59c68dc2d687469ab90a0e0f0688f382-jhpv","namespace":"garden-okq00q6"},"dnsProviderName":"openstack-designate","projectName":"okq00q6","hasCostObject":false},"quotas":[],"data":{"OS_AUTH_URL":"****************","applicationCredentialID":"****************","applicationCredentialSecret":"****************","domainName":"ams2-fuga-cloud-bv-10a6bd9","tenantName":"ams2-Cyso Cloud BV"}},{"metadata":{"resourceVersion":"9577533","namespace":"garden-okq00q6","name":"emk-project-59c68dc2d687469ab90a0e0f0688f382-saef","secretRef":{"name":"emk-project-59c68dc2d687469ab90a0e0f0688f382-saef","namespace":"garden-okq00q6"},"cloudProviderKind":"openstack","cloudProfileName":"fugacloud","projectName":"okq00q6","hasCostObject":false},"quotas":[],"data":{"applicationCredentialID":"****************","applicationCredentialSecret":"****************","domainName":"ams2-fuga-cloud-bv-10a6bd9","tenantName":"ams2-Cyso Cloud BV"}}]
      // let dnsSecrets = data.filter(item => item.metadata.dnsProviderName != undefined);
      // this.$store.commit('emk/SET_DNS_SECRETS', dnsSecrets);
        let currentNamespace = localStorage.getItem('current_namespace');
        if (currentNamespace) {
            getEmkSecrets()
            .then((response) => {
                let projectSecrets = response.data.filter(item => item.metadata.cloudProviderKind != undefined);
                let dnsSecrets = response.data.filter(item => item.metadata.dnsProviderName != undefined);
                this.$store.commit('emk/SET_PROJECT_SECRETS', projectSecrets);
                this.$store.commit('emk/SET_DNS_SECRETS', dnsSecrets);
                this.$store.commit('emk/SET_SECRETS', response.data);
                if (redirectToCreate) {
                    this.$router.push({ name: 'emk-create' });
                }
                if (fetchAfterCreation) {
                    this.$store.commit('emk/CREATING_SECRETS', false);
                }
            })
            .catch((error) => {
                console.error(error);
                this.showNotification('error', 'Fetching secrets failed');
            });
        }
    },

    stopWebsocket() {
        if (this.connection) {
            this.connection.close();
        }
    },

    unsubscribeShoots() {
        if (this.connection) {
            this.connection.send('4211["unsubscribe","shoots"]');
        }
    },

    startWebsocket(newlist) {
      // let data = {"garden-7ys6shw":[{"type":"MODIFIED","object":{"kind":"Shoot","apiVersion":"core.gardener.cloud/v1beta1","metadata":{"name":"el47uex7d7","namespace":"garden-7ys6shw","uid":"efcff31b-7de8-487b-b33c-324c44fcc28f","resourceVersion":"12854816","generation":4,"creationTimestamp":"2022-07-11T09:23:14Z","labels":{"networking.extensions.gardener.cloud/calico":"true","operatingsystemconfig.extensions.gardener.cloud/ubuntu":"true","provider.extensions.gardener.cloud/openstack":"true","shoot.gardener.cloud/status":"healthy"},"annotations":{"gardener.cloud/created-by":"marino@fuga.cloud"},"finalizers":["gardener"],"managedFields":[{"manager":"gardener-controller-manager","operation":"Update","apiVersion":"core.gardener.cloud/v1beta1","time":"2022-07-11T09:23:14Z","fieldsType":"FieldsV1","fieldsV1":{"f:metadata":{"f:labels":{"f:shoot.gardener.cloud/status":{}}}}},{"manager":"gardener-scheduler","operation":"Update","apiVersion":"core.gardener.cloud/v1beta1","time":"2022-07-11T09:23:14Z","fieldsType":"FieldsV1","fieldsV1":{"f:spec":{"f:seedName":{}}},"subresource":"binding"},{"manager":"unknown","operation":"Update","apiVersion":"core.gardener.cloud/v1beta1","time":"2022-07-11T09:23:14Z","fieldsType":"FieldsV1","fieldsV1":{"f:metadata":{"f:annotations":{".":{},"f:gardener.cloud/created-by":{}}},"f:spec":{"f:addons":{".":{},"f:kubernetesDashboard":{".":{},"f:authenticationMode":{},"f:enabled":{}},"f:nginxIngress":{".":{},"f:enabled":{},"f:externalTrafficPolicy":{}}},"f:cloudProfileName":{},"f:hibernation":{},"f:kubernetes":{"f:allowPrivilegedContainers":{},"f:enableStaticTokenKubeconfig":{},"f:kubeAPIServer":{".":{},"f:enableAnonymousAuthentication":{},"f:enableBasicAuthentication":{},"f:eventTTL":{},"f:requests":{".":{},"f:maxMutatingInflight":{},"f:maxNonMutatingInflight":{}}},"f:kubeControllerManager":{".":{},"f:nodeCIDRMaskSize":{},"f:nodeMonitorGracePeriod":{},"f:podEvictionTimeout":{}},"f:kubeProxy":{".":{},"f:enabled":{},"f:mode":{}},"f:kubelet":{".":{},"f:failSwapOn":{},"f:imageGCHighThresholdPercent":{},"f:imageGCLowThresholdPercent":{},"f:kubeReserved":{".":{},"f:cpu":{},"f:memory":{},"f:pid":{}},"f:serializeImagePulls":{}},"f:version":{}},"f:maintenance":{".":{},"f:autoUpdate":{".":{},"f:kubernetesVersion":{},"f:machineImageVersion":{}},"f:timeWindow":{".":{},"f:begin":{},"f:end":{}}},"f:networking":{"f:nodes":{},"f:type":{}},"f:provider":{"f:controlPlaneConfig":{},"f:infrastructureConfig":{},"f:type":{},"f:workers":{"k:{\"name\":\"worker-n4zim-1\"}":{".":{},"f:cri":{".":{},"f:name":{}},"f:machine":{".":{},"f:architecture":{},"f:image":{".":{},"f:name":{},"f:version":{}},"f:type":{}},"f:maxSurge":{},"f:maxUnavailable":{},"f:maximum":{},"f:minimum":{},"f:name":{},"f:systemComponents":{".":{},"f:allow":{}},"f:volume":{".":{},"f:size":{},"f:type":{}},"f:zones":{}}}},"f:purpose":{},"f:region":{},"f:secretBindingName":{},"f:systemComponents":{".":{},"f:coreDNS":{".":{},"f:autoscaling":{".":{},"f:mode":{}}}}}}},{"manager":"gardenlet","operation":"Update","apiVersion":"core.gardener.cloud/v1beta1","time":"2022-07-11T09:24:05Z","fieldsType":"FieldsV1","fieldsV1":{"f:metadata":{"f:finalizers":{".":{},"v:\"gardener\"":{}}}}},{"manager":"gardenlet","operation":"Update","apiVersion":"core.gardener.cloud/v1beta1","time":"2022-07-11T11:34:27Z","fieldsType":"FieldsV1","fieldsV1":{"f:status":{"f:advertisedAddresses":{".":{},"k:{\"name\":\"external\"}":{".":{},"f:name":{},"f:url":{}},"k:{\"name\":\"internal\"}":{".":{},"f:name":{},"f:url":{}}},"f:clusterIdentity":{},"f:conditions":{".":{},"k:{\"type\":\"APIServerAvailable\"}":{".":{},"f:lastTransitionTime":{},"f:lastUpdateTime":{},"f:message":{},"f:reason":{},"f:status":{},"f:type":{}},"k:{\"type\":\"ControlPlaneHealthy\"}":{".":{},"f:lastTransitionTime":{},"f:lastUpdateTime":{},"f:message":{},"f:reason":{},"f:status":{},"f:type":{}},"k:{\"type\":\"EveryNodeReady\"}":{".":{},"f:lastTransitionTime":{},"f:lastUpdateTime":{},"f:message":{},"f:reason":{},"f:status":{},"f:type":{}},"k:{\"type\":\"SystemComponentsHealthy\"}":{".":{},"f:lastTransitionTime":{},"f:lastUpdateTime":{},"f:message":{},"f:reason":{},"f:status":{},"f:type":{}}},"f:constraints":{".":{},"k:{\"type\":\"HibernationPossible\"}":{".":{},"f:lastTransitionTime":{},"f:lastUpdateTime":{},"f:message":{},"f:reason":{},"f:status":{},"f:type":{}},"k:{\"type\":\"MaintenancePreconditionsSatisfied\"}":{".":{},"f:lastTransitionTime":{},"f:lastUpdateTime":{},"f:message":{},"f:reason":{},"f:status":{},"f:type":{}}},"f:gardener":{"f:id":{},"f:name":{},"f:version":{}},"f:lastOperation":{".":{},"f:description":{},"f:lastUpdateTime":{},"f:progress":{},"f:state":{},"f:type":{}},"f:observedGeneration":{},"f:seedName":{},"f:technicalID":{},"f:uid":{}}},"subresource":"status"}]},"spec":{"addons":{"kubernetesDashboard":{"enabled":false,"authenticationMode":"token"},"nginxIngress":{"enabled":false,"externalTrafficPolicy":"Cluster"}},"cloudProfileName":"fugacloud","dns":{"domain":"el47uex7d7.7ys6shw.shoot.emk.fuga.cloud"},"hibernation":{"schedules":[]},"kubernetes":{"allowPrivilegedContainers":true,"kubeAPIServer":{"enableBasicAuthentication":false,"requests":{"maxNonMutatingInflight":400,"maxMutatingInflight":200},"enableAnonymousAuthentication":false,"eventTTL":"1h0m0s"},"kubeControllerManager":{"nodeCIDRMaskSize":24,"podEvictionTimeout":"2m0s","nodeMonitorGracePeriod":"2m0s"},"kubeProxy":{"mode":"IPTables","enabled":true},"kubelet":{"failSwapOn":true,"kubeReserved":{"cpu":"80m","memory":"1Gi","pid":"20k"},"imageGCHighThresholdPercent":50,"imageGCLowThresholdPercent":40,"serializeImagePulls":true},"version":"1.24.2","enableStaticTokenKubeconfig":true},"networking":{"type":"calico","pods":"100.96.0.0/11","nodes":"10.250.0.0/16","services":"100.64.0.0/13"},"maintenance":{"autoUpdate":{"kubernetesVersion":true,"machineImageVersion":true},"timeWindow":{"begin":"170000+0000","end":"180000+0000"}},"provider":{"type":"openstack","controlPlaneConfig":{"apiVersion":"openstack.provider.extensions.gardener.cloud/v1alpha1","kind":"ControlPlaneConfig","loadBalancerProvider":"amphora","zone":"ams2-c"},"infrastructureConfig":{"apiVersion":"openstack.provider.extensions.gardener.cloud/v1alpha1","floatingPoolName":"public","kind":"InfrastructureConfig","networks":{"workers":"10.250.0.0/16"}},"workers":[{"cri":{"name":"containerd"},"name":"worker-n4zim-1","machine":{"type":"p2.8xlarge","image":{"name":"ubuntu","version":"20.4.20220505"},"architecture":"amd64"},"maximum":4,"minimum":2,"maxSurge":1,"maxUnavailable":0,"volume":{"type":"tier-2","size":"50Gi"},"zones":["ams2-a","ams2-b","ams2-c"],"systemComponents":{"allow":true}}]},"purpose":"evaluation","region":"ams2","secretBindingName":"emk-project-59c68dc2d687469ab90a0e0f0688f382-26d5","seedName":"fuga-ams2-vera","systemComponents":{"coreDNS":{"autoscaling":{"mode":"horizontal"}}}},"status":{"conditions":[{"type":"APIServerAvailable","status":"True","lastTransitionTime":"2022-07-11T11:34:27Z","lastUpdateTime":"2022-07-11T11:34:27Z","reason":"HealthzRequestSucceeded","message":"API server /healthz endpoint responded with success status code."},{"type":"ControlPlaneHealthy","status":"True","lastTransitionTime":"2022-07-11T11:34:27Z","lastUpdateTime":"2022-07-11T11:34:27Z","reason":"ControlPlaneRunning","message":"All control plane components are healthy."},{"type":"EveryNodeReady","status":"True","lastTransitionTime":"2022-07-11T11:34:27Z","lastUpdateTime":"2022-07-11T11:34:27Z","reason":"EveryNodeReady","message":"All nodes are ready."},{"type":"SystemComponentsHealthy","status":"True","lastTransitionTime":"2022-07-11T11:34:27Z","lastUpdateTime":"2022-07-11T11:34:27Z","reason":"SystemComponentsRunning","message":"All system components are healthy."}],"constraints":[{"type":"HibernationPossible","status":"True","lastTransitionTime":"2022-07-11T11:34:27Z","lastUpdateTime":"2022-07-11T09:27:15Z","reason":"NoProblematicWebhooks","message":"All webhooks are properly configured."},{"type":"MaintenancePreconditionsSatisfied","status":"True","lastTransitionTime":"2022-07-11T11:34:27Z","lastUpdateTime":"2022-07-11T09:27:15Z","reason":"NoProblematicWebhooks","message":"All webhooks are properly configured."}],"gardener":{"id":"10abaf47096548195473d9bd0abb1d4fc74c79438cad05a4e028df2404459cf1","name":"gardenlet-56b8bd6455-xr7hf","version":"v1.50.1"},"hibernated":false,"lastOperation":{"description":"Shoot cluster has been successfully reconciled.","lastUpdateTime":"2022-07-11T11:34:27Z","progress":100,"state":"Succeeded","type":"Reconcile"},"observedGeneration":4,"seedName":"fuga-ams2-vera","technicalID":"shoot--7ys6shw--el47uex7d7","uid":"efcff31b-7de8-487b-b33c-324c44fcc28f","clusterIdentity":"shoot--7ys6shw--el47uex7d7-efcff31b-7de8-487b-b33c-324c44fcc28f-garden-cluster-identity","advertisedAddresses":[{"name":"external","url":"https://api.el47uex7d7.7ys6shw.shoot.emk.fuga.cloud"},{"name":"internal","url":"https://api.el47uex7d7.7ys6shw.internal.emk.fuga.cloud"}]}},"objectKey":"efcff31b-7de8-487b-b33c-324c44fcc28f"}]}
      // // data = {"garden-7ys6shw":[{"type":"MODIFIED","object":{"kind":"Shoot","apiVersion":"core.gardener.cloud/v1beta1","metadata":{"name":"sqp37qhb0e","namespace":"garden-7ys6shw","uid":"1417374b-2b30-431a-8516-b7cc916b1aae","resourceVersion":"12857644","generation":4,"creationTimestamp":"2022-07-11T11:48:58Z","labels":{"dnsrecord.extensions.gardener.cloud/openstack-designate":"true","networking.extensions.gardener.cloud/calico":"true","operatingsystemconfig.extensions.gardener.cloud/ubuntu":"true","provider.extensions.gardener.cloud/openstack":"true","shoot.gardener.cloud/status":"healthy"},"annotations":{"gardener.cloud/created-by":"marino@fuga.cloud","shoot.gardener.cloud/tasks":"deployInfrastructure,deployDNSRecordInternal,deployDNSRecordExternal,deployDNSRecordIngress"},"finalizers":["gardener.cloud/reference-protection","gardener"],"managedFields":[{"manager":"unknown","operation":"Update","apiVersion":"core.gardener.cloud/v1beta1","time":"2022-07-11T11:48:58Z","fieldsType":"FieldsV1","fieldsV1":{"f:metadata":{"f:annotations":{".":{},"f:gardener.cloud/created-by":{}}},"f:spec":{"f:addons":{".":{},"f:kubernetesDashboard":{".":{},"f:authenticationMode":{},"f:enabled":{}},"f:nginxIngress":{".":{},"f:enabled":{},"f:externalTrafficPolicy":{}}},"f:cloudProfileName":{},"f:dns":{".":{},"f:domain":{},"f:providers":{".":{},"k:{\"type\":\"openstack-designate\"}":{".":{},"f:domains":{".":{},"f:exclude":{},"f:include":{}},"f:primary":{},"f:secretName":{},"f:type":{},"f:zones":{".":{},"f:exclude":{},"f:include":{}}}}},"f:hibernation":{},"f:kubernetes":{"f:allowPrivilegedContainers":{},"f:enableStaticTokenKubeconfig":{},"f:kubeAPIServer":{".":{},"f:enableAnonymousAuthentication":{},"f:enableBasicAuthentication":{},"f:eventTTL":{},"f:requests":{".":{},"f:maxMutatingInflight":{},"f:maxNonMutatingInflight":{}}},"f:kubeControllerManager":{".":{},"f:nodeCIDRMaskSize":{},"f:nodeMonitorGracePeriod":{},"f:podEvictionTimeout":{}},"f:kubeProxy":{".":{},"f:enabled":{},"f:mode":{}},"f:kubelet":{".":{},"f:failSwapOn":{},"f:imageGCHighThresholdPercent":{},"f:imageGCLowThresholdPercent":{},"f:kubeReserved":{".":{},"f:cpu":{},"f:memory":{},"f:pid":{}},"f:serializeImagePulls":{}},"f:version":{}},"f:maintenance":{".":{},"f:autoUpdate":{".":{},"f:kubernetesVersion":{},"f:machineImageVersion":{}},"f:timeWindow":{".":{},"f:begin":{},"f:end":{}}},"f:networking":{"f:nodes":{},"f:type":{}},"f:provider":{"f:controlPlaneConfig":{},"f:infrastructureConfig":{},"f:type":{},"f:workers":{"k:{\"name\":\"worker-wo5ul-1\"}":{".":{},"f:cri":{".":{},"f:name":{}},"f:machine":{".":{},"f:architecture":{},"f:image":{".":{},"f:name":{},"f:version":{}},"f:type":{}},"f:maxSurge":{},"f:maxUnavailable":{},"f:maximum":{},"f:minimum":{},"f:name":{},"f:systemComponents":{".":{},"f:allow":{}},"f:volume":{".":{},"f:size":{},"f:type":{}},"f:zones":{}}}},"f:purpose":{},"f:region":{},"f:secretBindingName":{},"f:systemComponents":{".":{},"f:coreDNS":{".":{},"f:autoscaling":{".":{},"f:mode":{}}}}}}},{"manager":"gardener-controller-manager","operation":"Update","apiVersion":"core.gardener.cloud/v1beta1","time":"2022-07-11T11:48:59Z","fieldsType":"FieldsV1","fieldsV1":{"f:metadata":{"f:finalizers":{".":{},"v:\"gardener.cloud/reference-protection\"":{}},"f:labels":{"f:shoot.gardener.cloud/status":{}}}}},{"manager":"gardener-scheduler","operation":"Update","apiVersion":"core.gardener.cloud/v1beta1","time":"2022-07-11T11:48:59Z","fieldsType":"FieldsV1","fieldsV1":{"f:spec":{"f:seedName":{}}},"subresource":"binding"},{"manager":"gardenlet","operation":"Update","apiVersion":"core.gardener.cloud/v1beta1","time":"2022-07-11T11:48:59Z","fieldsType":"FieldsV1","fieldsV1":{"f:metadata":{"f:finalizers":{"v:\"gardener\"":{}}}}},{"manager":"gardenlet","operation":"Update","apiVersion":"core.gardener.cloud/v1beta1","time":"2022-07-11T11:49:00Z","fieldsType":"FieldsV1","fieldsV1":{"f:status":{"f:advertisedAddresses":{".":{},"k:{\"name\":\"external\"}":{".":{},"f:name":{},"f:url":{}},"k:{\"name\":\"internal\"}":{".":{},"f:name":{},"f:url":{}}},"f:clusterIdentity":{},"f:conditions":{".":{},"k:{\"type\":\"APIServerAvailable\"}":{".":{},"f:lastTransitionTime":{},"f:lastUpdateTime":{},"f:message":{},"f:reason":{},"f:status":{},"f:type":{}},"k:{\"type\":\"ControlPlaneHealthy\"}":{".":{},"f:lastTransitionTime":{},"f:lastUpdateTime":{},"f:message":{},"f:reason":{},"f:status":{},"f:type":{}},"k:{\"type\":\"EveryNodeReady\"}":{".":{},"f:lastTransitionTime":{},"f:lastUpdateTime":{},"f:message":{},"f:reason":{},"f:status":{},"f:type":{}},"k:{\"type\":\"SystemComponentsHealthy\"}":{".":{},"f:lastTransitionTime":{},"f:lastUpdateTime":{},"f:message":{},"f:reason":{},"f:status":{},"f:type":{}}},"f:constraints":{".":{},"k:{\"type\":\"CACertificateValiditiesAcceptable\"}":{".":{},"f:lastTransitionTime":{},"f:lastUpdateTime":{},"f:message":{},"f:reason":{},"f:status":{},"f:type":{}},"k:{\"type\":\"HibernationPossible\"}":{".":{},"f:lastTransitionTime":{},"f:lastUpdateTime":{},"f:message":{},"f:reason":{},"f:status":{},"f:type":{}},"k:{\"type\":\"MaintenancePreconditionsSatisfied\"}":{".":{},"f:lastTransitionTime":{},"f:lastUpdateTime":{},"f:message":{},"f:reason":{},"f:status":{},"f:type":{}}},"f:gardener":{"f:id":{},"f:name":{},"f:version":{}},"f:lastOperation":{".":{},"f:description":{},"f:lastUpdateTime":{},"f:progress":{},"f:state":{},"f:type":{}},"f:observedGeneration":{},"f:retryCycleStartTime":{},"f:seedName":{},"f:technicalID":{},"f:uid":{}}},"subresource":"status"}]},"spec":{"addons":{"kubernetesDashboard":{"enabled":false,"authenticationMode":"token"},"nginxIngress":{"enabled":false,"externalTrafficPolicy":"Cluster"}},"cloudProfileName":"fugacloud","dns":{"domain":"test.test","providers":[{"domains":{"include":["includ.dom"],"exclude":["exclsu.domain"]},"primary":true,"secretName":"emk-dns-59c68dc2d687469ab90a0e0f0688f382-sasm","type":"openstack-designate","zones":{"include":["incl.zones"],"exclude":["ex.zones"]}}]},"hibernation":{"schedules":[]},"kubernetes":{"allowPrivilegedContainers":true,"kubeAPIServer":{"enableBasicAuthentication":false,"requests":{"maxNonMutatingInflight":400,"maxMutatingInflight":200},"enableAnonymousAuthentication":false,"eventTTL":"1h0m0s"},"kubeControllerManager":{"nodeCIDRMaskSize":24,"podEvictionTimeout":"2m0s","nodeMonitorGracePeriod":"2m0s"},"kubeProxy":{"mode":"IPTables","enabled":true},"kubelet":{"failSwapOn":true,"kubeReserved":{"cpu":"80m","memory":"1Gi","pid":"20k"},"imageGCHighThresholdPercent":50,"imageGCLowThresholdPercent":40,"serializeImagePulls":true},"version":"1.24.2","enableStaticTokenKubeconfig":true},"networking":{"type":"calico","pods":"100.96.0.0/11","nodes":"10.250.0.0/16","services":"100.64.0.0/13"},"maintenance":{"autoUpdate":{"kubernetesVersion":true,"machineImageVersion":true},"timeWindow":{"begin":"110000+0000","end":"120000+0000"}},"provider":{"type":"openstack","controlPlaneConfig":{"apiVersion":"openstack.provider.extensions.gardener.cloud/v1alpha1","kind":"ControlPlaneConfig","loadBalancerProvider":"amphora","zone":"ams2-c"},"infrastructureConfig":{"apiVersion":"openstack.provider.extensions.gardener.cloud/v1alpha1","floatingPoolName":"public","kind":"InfrastructureConfig","networks":{"workers":"10.250.0.0/16"}},"workers":[{"cri":{"name":"containerd"},"name":"worker-wo5ul-1","machine":{"type":"p2.8xlarge","image":{"name":"ubuntu","version":"20.4.20220505"},"architecture":"amd64"},"maximum":4,"minimum":2,"maxSurge":1,"maxUnavailable":0,"volume":{"type":"tier-2","size":"50Gi"},"zones":["ams2-a","ams2-b","ams2-c"],"systemComponents":{"allow":true}}]},"purpose":"evaluation","region":"ams2","secretBindingName":"emk-project-59c68dc2d687469ab90a0e0f0688f382-26d5","seedName":"fuga-ams2-vera","systemComponents":{"coreDNS":{"autoscaling":{"mode":"horizontal"}}}},"status":{"conditions":[{"type":"APIServerAvailable","status":"Unknown","lastTransitionTime":"2022-07-11T11:48:59Z","lastUpdateTime":"2022-07-11T11:48:59Z","reason":"ConditionCheckError","message":"Precondition failed: operation could not be initialized"},{"type":"ControlPlaneHealthy","status":"Unknown","lastTransitionTime":"2022-07-11T11:48:59Z","lastUpdateTime":"2022-07-11T11:48:59Z","reason":"ConditionCheckError","message":"Precondition failed: operation could not be initialized"},{"type":"EveryNodeReady","status":"Unknown","lastTransitionTime":"2022-07-11T11:48:59Z","lastUpdateTime":"2022-07-11T11:48:59Z","reason":"ConditionCheckError","message":"Precondition failed: operation could not be initialized"},{"type":"SystemComponentsHealthy","status":"Unknown","lastTransitionTime":"2022-07-11T11:48:59Z","lastUpdateTime":"2022-07-11T11:48:59Z","reason":"ConditionCheckError","message":"Precondition failed: operation could not be initialized"}],"constraints":[{"type":"HibernationPossible","status":"Unknown","lastTransitionTime":"2022-07-11T11:48:59Z","lastUpdateTime":"2022-07-11T11:48:59Z","reason":"ConditionCheckError","message":"Precondition failed: operation could not be initialized"},{"type":"MaintenancePreconditionsSatisfied","status":"Unknown","lastTransitionTime":"2022-07-11T11:48:59Z","lastUpdateTime":"2022-07-11T11:48:59Z","reason":"ConditionCheckError","message":"Precondition failed: operation could not be initialized"},{"type":"CACertificateValiditiesAcceptable","status":"Unknown","lastTransitionTime":"2022-07-11T11:48:59Z","lastUpdateTime":"2022-07-11T11:48:59Z","reason":"ConditionCheckError","message":"Precondition failed: operation could not be initialized"}],"gardener":{"id":"10abaf47096548195473d9bd0abb1d4fc74c79438cad05a4e028df2404459cf1","name":"gardenlet-56b8bd6455-xr7hf","version":"v1.50.1"},"hibernated":false,"lastOperation":{"description":"Deploying external domain DNS record, Deploying internal domain DNS record, Waiting until main and event etcd report readiness, Waiting until shoot infrastructure has been reconciled","lastUpdateTime":"2022-07-11T11:49:08Z","progress":25,"state":"Processing","type":"Create"},"observedGeneration":4,"retryCycleStartTime":"2022-07-11T11:48:59Z","seedName":"fuga-ams2-vera","technicalID":"shoot--7ys6shw--sqp37qhb0e","uid":"1417374b-2b30-431a-8516-b7cc916b1aae","clusterIdentity":"shoot--7ys6shw--sqp37qhb0e-1417374b-2b30-431a-8516-b7cc916b1aae-garden-cluster-identity","advertisedAddresses":[{"name":"external","url":"https://api.test.test"},{"name":"internal","url":"https://api.sqp37qhb0e.7ys6shw.internal.emk.fuga.cloud"}]}},"objectKey":"1417374b-2b30-431a-8516-b7cc916b1aae"}]}
        let subscriptionDone = false;
        let allShoots = []
        if (!this.connection || newlist) {
            this.connection = new WebSocket("wss://emk.fuga.cloud/api/events/?EIO=4&transport=websocket")
            this.connection.onmessage = (event) => {
                let currentNameSpace = localStorage.getItem('current_namespace');
                if (event.data && event.data.startsWith('430[{"statusCode":200}]')) {
                    subscriptionDone = true;
                } else if (event.data && event.data.startsWith('430[{"statusCode":')) {
                    this.stopWebsocket();
                    this.showNotification('error', 'Fetching cluster has failed. Retrying...');
                } else if (event.data && event.data.startsWith('42["shoots",')) {
                    let data = JSON.parse(event.data.split('42["shoots",')[1].slice(0, -1));
                    if (data) {
                        allShoots.push(data.uid);
                        function onlyUnique(value, index, array) {
                            return array.indexOf(value) === index;
                        }
                        allShoots = allShoots.filter(onlyUnique);
                            // 4226["synchronize","shoots",["7670d766-4e29-4d79-a936-7d184d84bac9","b360bb10-b0a2-4c67-9754-8076857a2bb0","76888a8e-b147-4209-866c-dd92c883e7dd","58356219-a936-48ce-b60e-74d80257aed7","816af790-1175-493a-962d-42740e13c355","7371f61c-0615-4be3-9a4b-82710c859553","65b37ef9-a636-4ec3-94d5-06fed76f7974","93948229-4622-44b1-a712-5854a5d22dda","692a67d8-7835-442b-be63-3b86156ff7f3"]]
                            // 421["synchronize","shoots",["93948229-4622-44b1-a712-5854a5d22dda"]]
                        if (allShoots.length > 0) {
                            this.messageNumber += 1;
                            let data = '42' + this.messageNumber + '["synchronize","shoots",' + JSON.stringify(allShoots) + ']';
                            this.connection.send(data);
                        }
                    }
                } else if (event.data && event.data.startsWith('43')) {
                    if (event && event.data) {
                        let data = JSON.parse(event.data.split(/\[(.*)/s)[1].slice(0, -1));
                        allShoots = [];
                        data.items.forEach((clusterData) => {
                            if (clusterData && clusterData.status && clusterData.status.lastOperation && clusterData.status.lastOperation.type === 'Delete' && clusterData.status.lastOperation && clusterData.status.lastOperation.progress === 100) {
                                this.$store.commit('emk/REMOVE_CLUSTER',  clusterData);
                            } else if (clusterData && clusterData.status && clusterData.status !== 'Failure') {
                                this.$store.commit('emk/UPDATE_CLUSTER',  clusterData);
                            }
                        })
                        // this.$store.commit('emk/UPDATE_KEY');
                        // console.log('countttteerrr', count)
                        // if (data[currentNameSpace]
                        //     && data[currentNameSpace][0].status.lastOperation
                        //     && data[currentNameSpace][0].status.lastOperation.type === 'Reconcile'
                        //     && data[currentNameSpace][0].status.lastOperation.progress === 100
                        //     && count === 0
                        //     && data[currentNameSpace][0].status.lastOperation.lastUpdateTime
                        //     && localStorage.getItem('isFuga') ? true : false ) {
                        //       count += 1;
                        //       let clusterName = data[currentNameSpace][0].metadata.name;
                        //       const img = 'https://cdn.cyso.nl/fuga-assets/dist/images/humans/large/marino.png';
                        //       console.log('Name ', data[currentNameSpace][0].metadata.name )
                        //       console.log('Name ', data[currentNameSpace][0].status.lastOperation )
                        //
                        //       this.sendPushNotification(`Whoop Whoop! Your cluster "${clusterName}" is now ready.`, 'You can now do your magic 👍', img)
                        // }
                        //   if (actionType) {
                        //     if (actionType === 'MODIFIED') {
                        //         data.uid
                        //         this.connection.send('420["subscribe","shoots",{"namespace":"' + currentNameSpace + '"}]');
                        //         4217["synchronize","shoots",["76888a8e-b147-4209-866c-dd92c883e7dd"]]
                        //     }
                        //   }
                    }
                } else if (event.data == 2) {
                    this.connection.send(3);
                } else if (event.data.startsWith('40')) {
                    let namespaces = []
                    this.$store.state.emk.namespaces.forEach((item, i) => {
                        let itemData = {}
                        itemData.namespace = item.metadata.namespace;
                        itemData.filter = null;
                        namespaces.push(itemData);
                    });
                    if (currentNameSpace) {
                        this.connection.send('420["subscribe","shoots",{"namespace":"' + currentNameSpace + '"}]');
                    } else {
                        this.connection.send('421["subscribe","shoots",{"namespace":"_all"}]');
                    }
                } else if (event.data.startsWith('44')) {
                    this.showNotification('error', JSON.parse(event.data.split('44/shoots,')[1]).message);
                }
            }
        }

        if (this.connection) {
            this.connection.onopen = (event) => {
                this.connection.send('40');
            }
            this.connection.onclose = (event) => {
                this.connection = false;
                let currentTeam = this.$store.state.team.current;
                if (currentTeam && currentTeam.emk_projects && currentTeam.emk_projects[0]) {
                    setTimeout(this.startWebsocket, 5000);
                }
            }
        }
    },

    createEmkProject(currentTeam) {
        if (!this.$store.state.emk.projectCreationStatus) {
            this.$store.commit('emk/SET_POLLING_PROJECT', true);
              createEmkProject(currentTeam)
                .then((response) => {
                    if (response.data.status === 'pending') {
                        this.pollEmkProject(response.data.team, response.data.id);
                    } else if (response.data.status === 'error') {
                        this.emkErrorMessage(error, 'Creating EMK project has failed')
                        this.$store.commit('emk/SET_POLLING_PROJECT', false);
                    } else {
                        this.emkErrorMessage('success', 'Creating EMK project is successful');
                        this.$store.commit('emk/SET_POLLING_PROJECT', false);
                    }
                })
                .catch((error) => {
                    if (error.response != undefined && error.response.status === 429) {
                    } else if (error.response != undefined && error.response.status === 400) {
                        this.emkErrorMessage(error, error.response.data);
                    } else {
                        this.emkErrorMessage(error, 'Creating EMK project has failed');
                        this.$store.commit('emk/TEAM_HAS_NAMESPACE',  true);
                    }
                    this.$store.commit('emk/SET_POLLING_PROJECT', false);
                });
        }
    },

    fetchEmkClusters(namespace) {
        getEmkClusters(namespace)
        .then((response) => {
            let clusters = response.data.items;
            if (clusters) {
                this.$store.commit('emk/SET',  clusters);
                this.$store.commit('emk/UPDATE_KEY');
                this.fetchEmkProjectExtend();
            }
            this.$store.commit('emk/IS_LOADING', false);
        })
        .catch((error) => {
            this.emkErrorMessage(error, 'Fetching EMK project has failed')
        });
    },

    fetchEmkProjectExtend() {
        this.$store.state.team.current.emk_projects.forEach((project) => {
            getEmkProjectExtend(project.id)
            .then((response) => {
                let data = {}
                data.id = project.id;
                data.extra = response.data;
                this.$store.commit('team/UPDATE_NAMESPACE', data);
            })
            .catch((error) => {
                this.emkErrorMessage(error, 'Fetching EMK project data has failed')
            });
        })
    },

    pollEmkProject() {
        this.$store.commit('emk/SET_POLLING_PROJECT', true);
        let handle = setInterval(() => {
            getEmkProject()
            .then((response) => {
                if (response.data[0].status === 'ready') {
                    clearInterval(handle);
                    setTimeout(() => {
                        this.setUserData();
                        this.$store.commit('emk/SET_POLLING_PROJECT', false);
                    }, 3000);
                }
            })
            .catch((error) => {
                this.emkErrorMessage(error, 'Fetching EMK project has failed')
            });
        }, 2000);
    },

    fetchEmkClusterInfo(currentClusterId, namespace) {
        this.$store.commit('emk/SET_CURRENT_INFO', false);
        getEmkCLusterInfo(currentClusterId, namespace)
        .then((response) => {
            this.$store.commit('emk/SET_CURRENT_INFO', response.data);
        })
        .catch((error) => {
            this.emkErrorMessage(error, 'Get cluster info failed')
        });
    },

    async fetchCredentials() {
        let serviceName = 'credential';
        let servicesUrls = this.$store.state.services.list['identity'];
        const requestPromises = [];
        Object.keys(servicesUrls).forEach((key) => {
            const promise = getCredentials(servicesUrls[key], [key][0])
            .then((response) => {
                let regionName = servicesUrls[key].split('.')[0].split('://')[1];
                return this.addRegionToData(regionName, this.filterItemsWithCurrentProject(regionName, response.data.credentials));
            })
            requestPromises.push(promise);
        });
        this.promiseAllSettled(requestPromises, serviceName);
    },

    filterItemsWithCurrentProject(regionName, data, appCred) {
        let currentProject = JSON.parse(localStorage.getItem('current_project'));
        let region = regionName;
        if (regionName === 'core') {
            region = 'ams2';
        }
        if (appCred) {
          return data.filter(item => item.project_id === currentProject[region]);
        } else {
            return data.filter(item => item.tenant_id === currentProject[region]);
        }
    },

    async fetchInterfaces(instanceId, region) {
        getInterfaces(this.$store.state.services.list['compute'][region], instanceId, region)
        .then((response) => {
            response.data.interfaceAttachments.instance_id = instanceId;
            this.$store.commit('instance/ADD_INTERFACES', response.data.interfaceAttachments);
            this.$store.commit('instance/UPDATE_BUTTONS_KEY');
        })
    },

    async fetchApplicationCredentials() {
        let serviceName = 'appCredential';
        let servicesUrls = this.$store.state.services.list['identity'];
        const requestPromises = [];
        Object.keys(servicesUrls).forEach((key) => {
            const promise = getApplicationCredentials(servicesUrls[key], [key][0])
            .then((response) => {
                let regionName = servicesUrls[key].split('.')[0].split('://')[1];
                return this.addRegionToData(regionName, this.filterItemsWithCurrentProject(regionName, response.data.application_credentials, true));
            })
            requestPromises.push(promise);
        });
        this.promiseAllSettled(requestPromises, serviceName);
    },

    async createMultiRegionEmkSecret(emkCredential, redirectToCreate) {
        this.$store.commit('emk/CREATING_SECRETS', true);
        let project = JSON.parse(localStorage.getItem('current_project'));
        let randomString = this.randomString(4);
        let safeProjectName = JSON.parse(localStorage.getItem('current_project')).name.replace(/[^a-zA-Z0-9]/g,'-').toLowerCase()
        let prefixedName = 'emk-' + emkCredential + '-' + safeProjectName + '-' + randomString;
        this.fetchOsUser();
        let data = {
            "application_credential": {
                "name": prefixedName,
                "description": 'Special EMK '+ emkCredential +' Application Credential, created by Cyso Cloud',
            }
        }
        let regionUrls = []
        Object.keys(this.$store.state.services.list['identity']).forEach((key) => {
            regionUrls.push(this.$store.state.services.list['identity'][key]);
        })
        let firstUrl = regionUrls[0]

        createApplicationCredential(firstUrl, data, firstUrl.split('.')[0].split('://')[1])
        .then((response) => {
            if (regionUrls.length === 1) {
                this.createEmkSecret(response.data.application_credential, emkCredential, response.data.application_credential);
            } else {
                const requestPromises = [];
                const promise = regionUrls.forEach((regionUrl, key) => {
                    if (firstUrl !== regionUrl) {
                        let newData = {
                            "application_credential": {
                                "name": response.data.application_credential.name,
                                "description": response.data.application_credential.description,
                                "secret": response.data.application_credential.secret,
                            }
                        }

                        const promise = createApplicationCredential(regionUrl, newData, regionUrl.split('.')[0].split('://')[1])
                        .then((response) => {
                            return response.data.application_credential;
                        })
                        requestPromises.push(promise);
                    }
                });
                this.promiseAllEmkAppCreds(requestPromises, emkCredential, redirectToCreate);
            }
        })
        .catch((error) => {
            console.error(error);
            this.isLoading = false;
            this.$store.commit('appCredential/IS_LOADING', false);
            if (error.response && error.response.data.error.message) {
              this.showNotification('error', `${ error.response.data.error.message }`);
            } else {
              this.showNotification('error', `Creating application credential has failed`);
            }
        });
    },

    promiseAllEmkAppCreds(requestPromises, emkCredential, redirectToCreate) {
      Promise.allSettled(requestPromises)
      .then(response => {
            let successFullResponses = response.filter(item => item.status === 'fulfilled');
            let errorFullResponses = response.filter(item => item.status !== 'fulfilled');
            if (successFullResponses.length > 0) {
                setTimeout(() => {
                    this.createEmkSecret(successFullResponses[0].value, emkCredential, redirectToCreate);
                }, 500);
            }
            if (errorFullResponses.length > 0) {
                this.showNotification('error', 'Creating application credential has failed');
            }
      });
    },

    async createEmkSecret(appCredData, emkCredential, redirectToCreate) {
        let identityUrl = false;
        if (emkCredential === 'dns') {
            identityUrl = this.$store.state.services.list['identity'].core
        }
        let regions = this.$store.state.services.list['identity'];
        let safeProjectName = JSON.parse(localStorage.getItem('current_project')).name.replace(/[^a-zA-Z0-9]/g,'-').toLowerCase();
        let osUserData = this.$store.state.user.info.os;

        createEmkSecret(safeProjectName, appCredData, identityUrl, osUserData, redirectToCreate)
        .then((response) => {
            this.fetchEmkSecrets(redirectToCreate, true);
            this.saveNewItems(response.data.metadata, 'emk', 'name', 'SET_NEW_SECRET')

            this.showNotification('success', 'creating secret is successful');
        })
        .catch((error) => {
            console.error(error);
            this.$store.commit('accessRules/IS_LOADING', false);
            this.resourceErrorMessage(error, 'Creating EMK secret has failed')
        });
    },

    async fetchAccessRules(details) {
        let serviceName = 'accessRules';
        let servicesUrls = this.$store.state.services.list['identity'];
        const requestPromises = [];
        Object.keys(servicesUrls).forEach((key) => {
            const promise = getAccessRules(servicesUrls[key], [key][0])
            .then((response) => {
                let regionName = servicesUrls[key].split('.')[0].split('://')[1];
                return this.addRegionToData(regionName, response.data.access_rules);
            })
            requestPromises.push(promise);
        });
        this.promiseAllSettled(requestPromises, serviceName);
    },

    async fetchDNS() {
        let serviceName = 'dns';
        let servicesUrls = this.$store.state.services.list[serviceName];
        const requestPromises = [];
        Object.keys(servicesUrls).forEach((key) => {
            if ([key][0].includes('core')) {
                const promise = getDNSZones(servicesUrls[key], [key][0])
                .then((response) => {
                    let regionName = servicesUrls[key].split('.')[0].split('://')[1];
                    this.dnsStatusCheck(response.data.zones, regionName)
                    return this.addRegionToData(regionName, response.data.zones);
                })
                requestPromises.push(promise);
            }
          });
        this.promiseAllSettled(requestPromises, serviceName);
    },

    async fetchDNSRecords(nextUrl) {
      getDNSZoneRecords(this.$store.state.services.list['dns'][this.$store.state.dns.current.region], this.$store.state.dns.current.id, nextUrl, this.$store.state.dns.current.region)
          .then((response) => {
              if (!nextUrl) {
                  this.$store.commit('dns/SET_RECORDS', response.data.recordsets);
              } else {
                  response.data.recordsets.forEach((item) => {
                      this.$store.commit('dns/ADD_RECORDS', item);
                  });
              }
              if (response.data.links.next) {
                  this.fetchDNSRecords(response.data.links.next);
              } else {
                  this.$store.commit('dns/RECORD_KEY');
                  this.$store.commit('dns/RECORDS_IS_LOADING', false);
              }
              // this.$store.commit('dns/SET_RECORDS', response.data.recordsets);
              this.dnsRecordStatusCheck(response.data.recordsets);
              this.$store.commit('dns/RECORD_KEY');
              // this.$store.commit('dns/RECORDS_IS_LOADING', false);
          })
          .catch((error) => {
              console.error(error);
              this.$store.commit('dns/RECORDS_IS_LOADING', false);
              this.showNotification('error', `Fetching DNS Zones has failed`);
          });
    },

    async dnsStatusCheck(data, region) {
        data.forEach((item) => {
          if (this.pollingDnsStatus(item.status)) {
              let handle = setInterval(() => {
                  getDNSZoneDetails(this.$store.state.services.list['dns'][region], item.id, region)
                  .then((response) => {
                    this.$store.commit('dns/UPDATE', response.data);
                    this.$store.commit('dns/UPDATE_KEY');
                    if (!this.pollingDnsStatus(response.data.status)) {
                        clearInterval(handle);
                    }
                  })
                  .catch((error) => {
                      if (error.response != undefined && error.response.status === 404) {
                        clearInterval(handle);
                        this.fetchDNS();
                        this.$store.commit('dns/UPDATE_KEY');
                        this.showNotification('success', 'Deleting DNS zone is successful');
                      }
                  });
              }, 2000);
          }
        })
    },

    async dnsRecordStatusCheck(data) {
        data.forEach((item) => {
          if (this.pollingDnsStatus(item.status)) {
              let handle = setInterval(() => {
                  getDNSRecordDetails(this.$store.state.services.list['dns'].core, this.$store.state.dns.current.id, item.id, 'core')
                  .then((response) => {
                    this.$store.commit('dns/UPDATE_RECORD', response.data);
                    this.$store.commit('dns/RECORD_KEY');
                    if (!this.pollingDnsStatus(response.data.status)) {
                        clearInterval(handle);
                    }
                  })
                  .catch((error) => {
                      if (error.response != undefined && error.response.status === 404) {
                        clearInterval(handle);
                        this.fetchDNS();
                        this.$store.commit('dns/RECORD_KEY');
                        this.showNotification('success', 'Deleting DNS record is successful');
                      }
                  });
              }, 2000);
          }
        })
    },

    pollingDnsStatus(status) {
        if (status !== 'PENDING') {
            return false;
        } else {
            return true;
        }
    },

    async fetchReverseDNS() {
        let serviceName = 'dns';
        let servicesUrls = this.$store.state.services.list[serviceName];
        const requestPromises = [];
        Object.keys(servicesUrls).forEach((key) => {
            const promise = getReversDNS(servicesUrls[key], [key][0])
            .then((response) => {
                let regionName = servicesUrls[key].split('.')[0].split('://')[1];
                if (response.data.floatingips.find(item => item.status === 'PENDING')) {
                    setTimeout(() => {
                        this.fetchReverseDNS();
                    }, 5000);
                }
                return this.addRegionToData(regionName, response.data.floatingips);
            })
            requestPromises.push(promise);
        });
        this.promiseAllSettled(requestPromises, serviceName, 'SET_REVERSE_DNS');
    },

    async fetchFixedReverseDNS() {
        let serviceName = 'dns';
        let servicesUrls = this.$store.state.services.list[serviceName];
        const requestPromises = [];
        Object.keys(servicesUrls).forEach((key) => {
            const promise = getFixedReversDNS(servicesUrls[key], [key][0])
            .then((response) => {
                let regionName = servicesUrls[key].split('.')[0].split('://')[1];
                if (response.data.fixedips.find(item => item.status === 'PENDING')) {
                    setTimeout(() => {
                        this.fetchFixedReverseDNS();
                    }, 5000);
                }
                return this.addRegionToData(regionName, response.data.fixedips, 'fixedIps');
            })
            requestPromises.push(promise);
        });
        this.promiseAllSettled(requestPromises, serviceName, 'SET_FIXED_REVERSE_DNS');
    },

    fetchAdjustments() {
        getAdjustments()
        .then((response) => {
            if (response.data.length > 0) {
                let lastTrialDate = new Date(response.data[response.data.length-1].end_date);
                let today = new Date();
                this.$store.commit('adjustment/SET', response.data);

                // console.log('between hours', Math.round(differenceInHours(today,lastTrialDate) / 24));
                // this.$store.commit('adjustment/SET_DAYS_LEFT', Math.round(differenceInHours(today,lastTrialDate) / 24));

                let addedDays = 0;
                // response.data.forEach((item) => {
                //     addedDays += Math.round(differenceInHours(item.end_date,item.start_date) / 24);
                // });
                this.$store.commit('adjustment/DAYS_ADDED', addedDays);
            }
        })
        .catch((error) => {
            console.error(error);
        });
    },

    fetchEmkMembers() {
        getEmkMembers()
        .then((response) => {
            this.$store.commit('emk/SET_ACCOUNTS', response.data.filter(item => item.username.includes('system:serviceaccount')));
        })
        .catch((error) => {
            console.error(error);
            if (noCurrentNameSpace) {
                this.showNotification('error', 'Fetching NameSpaces failed');
            }
        });
    },

    fetchEmkMemberDetails(accountName) {
        getEmkMemberDetails(accountName)
        .then((response) => {
              this.$store.commit('emk/SET_CURRENT_ACCOUNT', response.data);
              this.$store.commit('emk/UPDATE_KEY_FORM');
        })
        .catch((error) => {
            console.error(error);
            if (noCurrentNameSpace) {
                this.showNotification('error', 'Fetching NameSpaces failed');
            }
        });
    },

    createEmkCluster(namespace, data) {
        createEmkCluster(namespace, data)
        .then((response) => {
            this.showNotification('success', 'Creating cluster..');
            this.fetchEmkClusters(namespace);
            if (this.$router.currentRoute.name !== 'managed-kubernetes') {
                this.$router.push({ name: 'managed-kubernetes' });
            }
            this.isLoading = false;
        })
        .catch((error) => {
            console.error(error);
            this.isLoading = false;
            this.emkErrorMessage(error, 'Creating cluster has failed');
        });
    },

    fetchOsUser() {
        getOsUser()
        .then((response) => {
            this.$store.commit('user/SET_OS_DATA', response.data);
        })
        .catch((error) => {
            this.showNotification('error', `Fetching OS user data has failed`);
        });
    },

    pollOsUserStatus() {
        this.$store.commit('misc/DEPLOYING_ENVIRONMENT', true);
        let handle = setInterval(() => {
            getOsUser()
            .then((response) => {
                let data = false;
                if (response.data && response.data.provs && response.data.provs.length > 0) {
                    data = response.data.provs.filter(item => item.status !== 'ACTIVE');
                }
                if (data && data.length === 0) {
                    clearInterval(handle);
                    setTimeout(() => {
                        this.refreshToken();
                        this.$router.push({ name: 'home' });
                        this.showNotification('success', 'Project is ready for use');
                    }, 2000);
                }
            })
            .catch((error) => {
                this.showNotification('error', `Fetching OS user data has failed`);
            });
        }, 3000);
    },
  }
});
